import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Row, Col, Label, Alert } from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import "react-dropzone-uploader/dist/styles.css";
import DatePicker from "react-datepicker";
import {
  checkWhiteSpaces,
  numberHavells,
  validateUrlHavells,
  alphaNumeric,
  email,
  displayPublishOnDate,
  alphabetsOnly,
  notify,
  userDetails,
} from "../../../helper";
import {
  AddNewSupplierRequest,
  getCountryService,
  getCurrencyList,
  getCurrencyScaleList,
  getDistrictSelection,
  getRelationService,
  getServiceHowDidYouHearAbout,
  getStateSelection,
  getSupplierFormDetailForUpdate,
  getSupplierSpecializationService,
  getTyBuisness,
  getTypeEstablishment,
  getYearOfBuisnessService,
} from "./Actions";
import DayTime from "../../common/DayTimeWrapper";
import HeaderTitle from "../../common/HeaderTitle";
import Toaster from "../../common/Toaster";
import TooltipCustom from "../../common/Tooltip";
import {
  SearchableSelectHookForm,
  TextAreaHookForm,
  TextFieldHookForm,
} from "../../layout/HookFormInputs";
import {
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import FileUpload from "../FileUpload";
import LoaderCustom from "../../common/LoaderCustom";
import confirmImgMain from "../../../assests/images/logo/havells-h-logo.svg";
import { API } from "../../../config/constants";
import axiosHelper from "../../../axiosHelper";

function AddNewSupplier(props) {
  let detail = JSON.parse(localStorage.getItem("userDetail"));
  const urlParams = new URLSearchParams(window.location.search);
  const Mode = urlParams.get("mode");
  const id = urlParams.get("id");
  const [fileData, setFileData] = useState(null);

  const [hasSisterConcernWithQRGVendorCodeChanged, setHasSisterConcernWithQRGVendorCodeChanged] = useState(false);
  const [isSisterConcernWithQRGVendorCodeValid, setIsSisterConcernWithQRGVendorCodeValid] = useState(false);

  const [hasSupplierCodeChanged, setHasSupplierCodeChanged] = useState(false);
  const [isSupplierCodeValid, setIsSupplierCodeValid] = useState(false);

  const [hasGSTINChanged, setHasGSTINChanged] = useState(false);
  const [isGstValid, setIsGstValid] = useState(false);
  const [showPageLoader, setShowPageLoader] = useState(false);
  const [supplierOrigin, setSupplierOrigin] = useState("1");
  const [originId, setoriginId] = useState(null);
  const [selectedEstablishmentType, setSelectedEstablishmentType] =
    useState(null);
  const [buisnessType, setBuisnessType] = useState([]);
  const [supplierSpecialization, setSupplierSpecialization] = useState([]);
  const [workAddressType, setWorkAddressType] = useState(true);
  const [yearOfBuisness, setYearOfBuisness] = useState([]);
  const [showExplanation, setShowExplanation] = useState(false);
  const [relationList, setRelationList] = useState([]);
  const [selectedSupplierSpecialization, setSelectedSupplierSpecialization] =
    useState(null); // Default value
  const [masterCurrencyList, setCurrencyMasterList] = useState([]);
  const [currencyScaleData, setCurrencyScaleData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [stateOptionData, setOptionData] = useState([]);
  const [cityOptionData, setCityOptionData] = useState([]);
  const [howDidYouHearAboutData, setHowDidYouHearAbout] = useState(null);
  const [districtOptionData, setDistrictOptionData] = useState([]);
  const [effectiveDate, setEffectiveDate] = useState(null);
  const [effectiveDateISO, setEffectiveDateISO] = useState(null);
  const [setDisable, setSetDisable] = useState(false);
  const [establishment1, setEstablishment] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showSupplierOriginPopup, setShowSupplierOriginPopup] = useState(false);
  const [trackkingApplicationId, settrackkingApplicationId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [establishmentOptions, setEstablishmentOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  const [isoFile, setIsoFile] = useState({
    fileName: fileData?.ISO9001IATFCertificateNumberAttachmentName,
    base64String: "",
    fileType: "",

  });
  const [panCardFile, setPanCardFile] = useState({
    fileName: fileData?.PANCardAttachmentName,
    base64String: "",
    fileType: "",

  });
  const [gstinFile, setGstinFile] = useState({
    fileName: fileData?.GISTINNumberAttachmentName,
    base64String: "",
    fileType: "",
  });
  const [factoryCertificateFile, setFactoryCertificateFile] = useState({
    fileName: fileData?.FactoryFactoryLicenseAttachmentName,
    base64String: "",
    fileType: "",
  });
  const [registerFile, setRegisterFile] = useState({
    fileName: fileData?.RegisteredUnderMSMEDActAttachmentName,
    base64String: "",
    fileType: "",
  });
  const [registerLicenseFile, setRegisterLisenseFile] = useState({
    fileName: fileData?.CompanyRegistrationOrLicenseAttachmentName,
    base64String: "",
    fileType: "",
  });
  const [companyProfile, setCompanyProfile] = useState({
    fileName: fileData?.CompanyProfileAttachmentName,
    base64String: "",
    fileType: "",
  });
  const [isDateValid, setIsDateValid] = useState(true);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [showPopupForCancel, setShowPopupForCancel] = useState(false);
  const [actionType, setActionType] = useState("");
  // Function to handle checkbox click
  const handleCheckboxClick = () => {
    // Update state to indicate if any checkbox is checked
    setCheckboxChecked((checkBoxChecked) => !checkBoxChecked);
  };

  const history = useHistory();

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    setValue,
    getValues,
    reset,
    setError,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      IsExistingSupplier: "true",
      supplierOrigin: "1",
      HasSisterConcernWithQRG: "true",
      HasISO9001OrIATF16949: "true",
      HasRelationWithQRGEmployees: "true",
      IsRegisteredUnderMSMEDAct: "true",
      HasFactoryLicense: "true",
      WorkAddressType: workAddressType,
      FactoryLicenseExpiryDate: effectiveDate
        ? DayTime(effectiveDate).toDate()
        : null,
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const fetchData = async () => {
    setValue("MobileNo", detail?.mobileNo);
    setValue("Email", detail?.email);
    // Fetch data for the first use case
    getYearOfBuisnessCorporation();
    getHowDidYouHearAboutUs();
    getRelationshipMasterList();
    getCountryMasterList();
    getTypeOfEstablishment();
    getCurrrencyMasterList();
    getTypeOfBuisness();
  };
  const defaultCountry = countryList.find(
    (country) => country?.Name === "India"
  );

  const defaultCurrencyList = masterCurrencyList.find(
    (currency) => currency.CurrencyName === "INR"
  );
  useEffect(() => {
    if (defaultCurrencyList && defaultCountry && supplierOrigin === "1") {
      void handleCountryChange(defaultCountry?.Id, false);
      void handleCurrencyChange(defaultCurrencyList?.PCId, false);
      // (defaultCountry?.Id, false);
      setValue("Country", {
        value: defaultCountry.Id || "",
        label: defaultCountry.Name || "", // Provide the label property
      });
      setValue("LastYearTurnoverCurrency", {
        value: defaultCurrencyList?.PCId || "",
        label: defaultCurrencyList?.CurrencyName || "", // Provide the label property
      });
      // Disable the field when supplierOrigin is '1'
      setIsDateValid(true);
    } else {
      setCurrencyScaleData([]);
      setOptionData([]);
      // setValue("Country", null); // Clear the field
      // Enable the field if supplierOrigin is not '1'
      setIsDateValid(false);
    }

  }, [defaultCountry, supplierOrigin, defaultCurrencyList]);

  useEffect(() => {
    // setShowPopup(true);
    // Fetch all the data when the component mounts and when 'selectedBusinessTypeId' or 'countySelectId' changes
    void fetchData();
    if (id) {
      const establishmentOptions = renderListing("establishment");
      setEstablishmentOptions(establishmentOptions);
      setLoading(true);
      getSupplierFormDetailForUpdate(id)
        .then(async (res) => {
          const userData = res?.Data;
          const supplierDeta = { ...userData[0] };
          if (supplierDeta?.GISTINNumber && Mode === "edit") {
            setIsGstValid(true)
          }
          if (supplierDeta?.VendorCode && Mode === "edit") {
            setIsSupplierCodeValid(true)
          }
          if (supplierDeta?.SisterConcernWithQRGVendorCode && Mode === "edit") {
            setIsSisterConcernWithQRGVendorCodeValid(true)
          }
          const initialWorkAddressType = supplierDeta?.WorkAddressType ?? true;
          setFileData(supplierDeta);
          setValue("WorkAddressType", initialWorkAddressType);
          setValue(
            "CompanyProfileWebsite",
            supplierDeta?.CompanyProfileWebsite
          );
          setIsoFile(
            {
              fileName: supplierDeta?.ISO9001IATFCertificateNumberAttachmentName,
              base64String: "",
              fileType: "",
            }
          );
          setPanCardFile({
            fileName: supplierDeta?.PANCardAttachmentName,
            base64String: "",
            fileType: "",
          }
          );
          setGstinFile({
            fileName: supplierDeta?.GISTINNumberAttachmentName,
            base64String: "",
            fileType: "",
          });
          setFactoryCertificateFile(
            {
              fileName: supplierDeta?.FactoryFactoryLicenseAttachmentName,
              base64String: "",
              fileType: "",
            }
          );
          setRegisterFile(
            {
              fileName: supplierDeta?.RegisteredUnderMSMEDActAttachmentName,
              base64String: "",
              fileType: "",
            }
          );
          setRegisterLisenseFile(
            {
              fileName: supplierDeta?.CompanyRegistrationOrLicenseAttachmentName,
              base64String: "",
              fileType: "",
            }

          );
          setCompanyProfile({
            fileName: supplierDeta?.CompanyProfileAttachmentName,
            base64String: "",
            fileType: "",
          });
          setSelectedEstablishmentType(supplierDeta?.TypeOfEstablishmentId);
          setWorkAddressType(supplierDeta?.WorkAddressType);

          const formattedDateIso = supplierDeta?.FactoryLicenseExpiryDate
            ? DayTime(
              supplierDeta?.FactoryLicenseExpiryDate,
              "YYYY-MM-DDTHH:mm:ss.SSSZ"
            ).format("MM/DD/YYYY")
            : null;
          if (formattedDateIso) {
            setEffectiveDate(formattedDateIso);
            setValue("FactoryLicenseExpiryDate", formattedDateIso, {
              shouldValidate: true,
            });
          }

          const formattedDate = supplierDeta?.ISO9001IATFExpiryDate
            ? DayTime(
              supplierDeta?.ISO9001IATFExpiryDate,
              "YYYY-MM-DDTHH:mm:ss.SSSZ"
            ).format("MM/DD/YYYY")
            : null;
          if (formattedDate) {
            setEffectiveDateISO(formattedDate);
            setValue("ISO9001IATFExpiryDate", formattedDate, {
              shouldValidate: true,
            });
          }

          void handleCountryChange(
            supplierDeta?.CountryId || defaultCountry?.Id,
            false
          );
          void handleStateChange(supplierDeta?.StateId, false);
          void handleCurrencyChange(
            supplierDeta?.LastYearTurnoverCurrencyId ||
            defaultCurrencyList?.PCId,
            false
          );
          void handleBuisnessTypeChange(supplierDeta?.TypeOfBusiness, false);
          setValue("CompanyName", supplierDeta?.CompanyName);
          setValue("ContactPersonName", supplierDeta?.ContactPersonName);
          setValue(
            "ContactPersonDesignation",
            supplierDeta?.ContactPersonDesignation
          );
          setValue("PANNo", supplierDeta?.PANNo);
          setValue("GISTINNumber", supplierDeta?.GISTINNumber);
          setValue("TotalStaff", supplierDeta?.TotalStaff);
          setValue("TotalWorkers", supplierDeta?.TotalWorkers);
          setValue("VendorCode", supplierDeta?.VendorCode);
          setValue("QRGEmployeeLocation", supplierDeta?.QRGEmployeeLocation);

          setValue(
            "SisterConcernWithQRGVendorCode",
            supplierDeta?.SisterConcernWithQRGVendorCode
          );
          setValue(
            "ISO9001IATFCertificateNumber",
            supplierDeta?.ISO9001IATFCertificateNumber
          );
          setValue("FactoryCertificateNo", supplierDeta?.FactoryCertificateNo);
          setValue("QRGEmployeeCode", supplierDeta?.QRGEmployeeCode);
          setValue("QRGEmployeeName", supplierDeta?.QRGEmployeeName);
          setValue("MSMERegistrationNo", supplierDeta?.MSMERegistrationNo);
          setValue(
            "CompanyRegistrationOrLicenseNo",
            supplierDeta?.CompanyRegistrationOrLicenseNo
          );
          setValue("LastYearTurnover", supplierDeta?.LastYearTurnover);
          setValue(
            "CompanyInfrastructureService",
            supplierDeta?.CompanyInfrastructureService
          );
          setValue("Street", supplierDeta?.Street);
          // Inside your useEffect or the relevant part of your component
          setValue("BuildingPlotNo", supplierDeta?.BuildingPlotNo);
          setValue("RelatedInputField", supplierDeta?.RelatedInputField);
          setValue("District", supplierDeta?.DistrictName);
          setValue("City", supplierDeta?.CityName);
          setValue("PostalCode", supplierDeta?.PostalCode);
          // setSelectedEstablishmentType(supplierDeta?.TypeOfEstablishment);
          setValue("TypeOfEstablishment", {
            value: supplierDeta?.TypeOfEstablishmentId || "",
            label: supplierDeta?.TypeOfEstablishmentName,
          });
          setValue("YearOfBusinessIncorporation", {
            value: supplierDeta?.YearOfBusinessIncorporationId || "",
            label: supplierDeta?.YearOfBusinessIncorporationName,
          });
          setValue("TypeOfBusiness", {
            value: supplierDeta?.TypeOfBusiness || "",
            label: supplierDeta?.BusinessTypeName,
          });
          setValue("SupplierSpecialization", {
            value: supplierDeta?.SupplierSpecialization || "",
            label: supplierDeta?.SpecializationName || "", // Provide the label property
          });
          setValue("OtherSpecialization", {
            value: supplierDeta?.OtherSpecialization || "",
            label: supplierDeta?.OtherSpecializationName || "", // Provide the label property
          });
          setValue("Relation", {
            value: supplierDeta?.RelationId || "",
            label: supplierDeta?.RelationName || "", // Provide the label property
          });
          setValue("Country", {
            value: supplierDeta?.CountryId || "",
            label: supplierDeta?.CountryName || "", // Provide the label property
          });
          setValue("State", {
            value: supplierDeta?.StateId || "",
            label: supplierDeta?.StateName || "", // Provide the label property
          });

          setValue("LastYearTurnoverCurrency", {
            value: supplierDeta?.LastYearTurnoverCurrencyId || "",
            label: supplierDeta?.LastYearTurnoverCurrencyName || "", // Provide the label property
          });
          setValue("LastYearTurnoverNumberScale", {
            value: supplierDeta?.CurrencyScaleId || "",
            label: supplierDeta?.CurrencyScaleName || "", // Provide the label property
          });
          setValue("HowDidYouHearAboutUs", {
            value: supplierDeta?.HowDidYouHearAboutUsId || "",
            label: supplierDeta?.HowDidYouHearAboutUsName || "", // Provide the label property
          });
          setValue("OrganizationType", {
            value: supplierDeta?.OrganizationTypeId || "",
            label: supplierDeta?.OrganizationTypeName || "", // Provide the label property
          });
          setValue("IsExistingSupplier", `${supplierDeta?.IsExistingSupplier}`);
          setValue(
            "HasSisterConcernWithQRG",
            `${supplierDeta?.HasSisterConcernWithQRG}`
          );
          setValue(
            "HasISO9001OrIATF16949",
            `${supplierDeta?.HasISO9001OrIATF16949}`
          );
          setValue("HasFactoryLicense", `${supplierDeta?.HasFactoryLicense}`);
          setValue("HasFactoryLicense", `${supplierDeta?.HasFactoryLicense}`);
          setValue(
            "HasRelationWithQRGEmployees",
            `${supplierDeta?.HasRelationWithQRGEmployees}`
          );
          setValue(
            "IsRegisteredUnderMSMEDAct",
            `${supplierDeta?.IsRegisteredUnderMSMEDAct}`
          );
          // setValue(setSupplierOrigin, `${supplierDeta?.SupplierOrigin}`)
          setSupplierOrigin(`${supplierDeta?.SupplierOrigin}`);
        })
        .catch((_error) => {
          // Handle error if needed
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);
  const handleChangeGST = async (e) => {
    const inputValue = e.target.value.toUpperCase(); // Convert input value to uppercase
    // Update the input value
    e.target.value = inputValue;

    // Check if the input value has reached 14 characters
    if (inputValue.length >= 15) {
      try {
        const response = await fetch(`http://10.10.1.100:8081/api/v1/SupplierRepositoryRegistration/GSTValidate?GSTIN=${inputValue}`);
        if (!response.ok) {
          setErrorMessage('Failed to validate GSTIN');
        } else {
          setErrorMessage('');
          // Proceed with other actions if needed
        }
      } catch (error) {
        setErrorMessage('Failed to validate GSTIN');
        // Handle error if necessary
      }
    } else {
      // If input value is less than 14 characters, clear the error message
      setErrorMessage('');
    }
  };
  const handlePanCardDelete = () => {
    setPanCardFile(p => (
      {
        ...p, isRemove: true
      }
    ));
  };
  const handleFactoryFactoryLicenseAttachmentFile = () => {
    setFactoryCertificateFile(p => (
      {
        ...p, isRemove: true
      }
    ));
  };
  const handlISODelete = () => {
    setIsoFile(p => (
      {
        ...p, isRemove: true
      }
    ));
  };
  const handleRegisterDelete = () => {
    setRegisterFile(p => (
      {
        ...p, isRemove: true
      }
    ));
  };
  const handleRegisterLicenseDelete = () => {
    setRegisterLisenseFile(p => (
      {
        ...p, isRemove: true
      }
    ));
  };
  const handleCompanyProfileDelete = () => {
    setCompanyProfile(p => (
      {
        ...p, isRemove: true
      }
    ));
  };
  const handleGSTINDelete = () => {
    setGstinFile(p => (
      {
        ...p, isRemove: true
      }
    ));

  };

  const onPopupConfirm = () => {
    setShowPopup(false);
    history.push("/supplier-list-all");
  };
  const onPopupConfirmForCancel = () => {
    setShowPopupForCancel(false);
    history.push("/supplier-list-all");
  };
  const closePopUp = (e) => {
    // setShowPopup(false);
    e.preventDefault();
  };
  const closePopUpForCancel = (e) => {
    // setShowPopup(false);
    setShowPopupForCancel(false);
  };

  const handleSupplierRadioChange = (event) => {
    setShowSupplierOriginPopup(true);
    setoriginId(event.target.id);
    setSelectedEstablishmentType(null);
    setShowExplanation(false);
  };

  const onConfirmSupplierPopup = (event) => {
    setSupplierOrigin(originId);
    // handleResetFields();
    reset({
      CompanyName: "",
      SupplierRepositoryRegistrationId: "",
      SupplierOrigin: "",
      TypeOfEstablishment: "",
      RelatedInputField: "",
      YearOfBusinessIncorporation: "",
      ContactPersonName: "",
      ContactPersonDesignation: "",
      IsExistingSupplier: "true",
      PANNo: "",
      PanCardAttachment: "",
      GISTINNumberAttachment: "",
      GISTINNumber: "",
      TypeOfBusiness: "",
      SupplierSpecialization: "",
      OtherSpecialization: "",
      TotalStaff: "",
      TotalWorkers: "",
      OtherSpecializationExplanation: "",
      VendorCode: "",
      HasSisterConcernWithQRG: "true",
      SisterConcernWithQRGVendorCode: "",
      HasISO9001OrIATF16949: "true",
      ISO9001IATFCertificateNumber: "",
      ISO9001IATFExpiryDate: "",
      ISO9001IATFCertificateNumberAttachment: "",
      FactoryFactoryLicenseAttachment: "",
      RegisteredUnderMSMEDActAttachment: "",
      CompanyRegistrationOrLicenseAttachment: "",
      CompanyProfileAttachment: "",
      HasFactoryLicense: "",
      FactoryCertificateNo: "",
      FactoryLicenseExpiryDate: "",
      HasRelationWithQRGEmployees: "true",
      CompanyInfrastructureService: "",
      Relation: "",
      QRGEmployeeCode: "",
      QRGEmployeeName: "",
      QRGEmployeeLocation: "",
      IsRegisteredUnderMSMEDAct: "true",
      OrganizationType: "",
      MSMERegistrationNo: "",
      CompanyRegistrationOrLicenseNo: "",
      CompanyProfileWebsite: "",
      LastYearTurnover: "",
      LastYearTurnoverCurrency: "",
      LastYearTurnoverNumberScale: "",
      HasFactoryLicense: "true",
      Street: "",
      BuildingPlotNo: "",
      Country: "",
      State: "",
      District: "",
      City: "",
      PostalCode: "",
      HowDidYouHearAboutUs: "",
      WorkAddressType: workAddressType,
      createdOn: "",
      approvedOn: "",
      updatedDate: "",
      requestStatus: "",
    });
    // setValue("ISO9001IATFExpiryDate", null); // Use the correct date format here
    setEffectiveDateISO(null);
    setEffectiveDate(null);
    setValue("FactoryLicenseExpiryDate", null);
    setShowSupplierOriginPopup(false);
    // Any other logic you want to perform on confirmation1
  };

  const dispatch = useDispatch();
  const establishment = [
    { label: "Micro", value: 2 },
    { label: "Small", value: 1 },
    { label: "Medium", value: 3 },
  ];

  const getTypeOfEstablishment = () => {
    getTypeEstablishment()
      .then((res) => {
        setEstablishment(res?.Data);
      })
      .catch(() => { });
  };
  const getTypeOfBuisness = () => {
    getTyBuisness()
      .then((res) => {
        setBuisnessType(res?.Data);
      })
      .catch(() => { });
  };
  const getYearOfBuisnessCorporation = () => {
    getYearOfBuisnessService()
      .then((res) => {
        setYearOfBuisness(res?.Data);
      })
      .catch(() => { });
  };
  const getRelationshipMasterList = () => {
    getRelationService()
      .then((res) => {
        setRelationList(res?.Data);
      })
      .catch(() => { });
  };
  const getCurrrencyMasterList = () => {
    getCurrencyList()
      .then((res) => {
        setCurrencyMasterList(res?.Data);
      })
      .catch(() => { });
  };
  const getCountryMasterList = () => {
    getCountryService()
      .then((res) => {
        setCountryList(res?.Data);
      })
      .catch(() => { });
  };
  const getHowDidYouHearAboutUs = () => {
    getServiceHowDidYouHearAbout()
      .then((res) => {
        setHowDidYouHearAbout(res?.Data);
      })
      .catch(() => { });
  };

  /**
   * @method renderListing
   * @description RENDER LISTING IN DROPDOWN
   */
  const renderListing = (label) => {
    if (label === "establishment") {
      let filteredEstablishmentList = establishment1;
      if (supplierOrigin === "2") {
        filteredEstablishmentList = establishment1.filter(
          (establishment) => establishment.Id !== 5
        );
      }
      return filteredEstablishmentList.map((typeofEstablishment) => ({
        value: typeofEstablishment.Id,
        label: typeofEstablishment.Name,
      }));
    }
    if (label === "HowDidYouHear") {
      return howDidYouHearAboutData?.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.SourceName,
      }));
    }
    if (label === "typeofBuisness") {
      return buisnessType.map((typeofBuisness) => ({
        value: typeofBuisness.Id,
        label: typeofBuisness.BusinessTypeName,
      }));
    }
    if (label === "supplierSpecialization") {
      return supplierSpecialization.map((supplierSpecialization) => ({
        value: supplierSpecialization.Id,
        label: supplierSpecialization.SpecializationName,
      }));
    }
    if (label === "otherSpecialization") {
      return otherSpecializationData.map((otherSpecialization) => ({
        value: otherSpecialization.Id,
        label: otherSpecialization.SpecializationName,
      }));
    }
    if (label === "yearOfBuisness") {
      return yearOfBuisness.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "relationEmployee") {
      return establishment.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.value,
        label: yearOfBuisnessIncorporation.label,
      }));
    }

    if (label === "relationEmployeeListing") {
      return relationList.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "currencyList") {
      let filteredEstablishmentList = masterCurrencyList;
      if (supplierOrigin === "2") {
        filteredEstablishmentList = masterCurrencyList.filter(
          (currencyList) => currencyList.CurrencyName !== "INR"
        );
      }
      return filteredEstablishmentList.map((typeofEstablishment) => ({
        value: typeofEstablishment.PCId,
        label: typeofEstablishment.CurrencyName,
      }));
    }
    if (label === "currencyListScale") {
      return currencyScaleData.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "Country") {
      // Check if supplier origin is set and remove India from the listing
      const filteredCountryList =
        supplierOrigin === "2"
          ? countryList.filter((country) => country.Name !== "India")
          : countryList;

      return filteredCountryList.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "State") {
      return stateOptionData.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "District") {
      return districtOptionData.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "City") {
      return cityOptionData.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.City,
      }));
    }
  };
  /**
   * @method handleEffectiveDateChange
   * @description Handle Effective Date
   */
  const handleEffectiveDateChange = (date) => {
    setEffectiveDate(displayPublishOnDate(date));
  };

  const handleDateChange = (date) => {
    setEffectiveDateISO(displayPublishOnDate(date));
  };

  const handleSubmitClick = (data, e, isSent) => {
    handleSubmit(() => onSubmit(data, e, isSent))();
  };

  // const handleIsoCertiicateUpload = (file, e) => {
  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size <= 5 * 1024 * 1024) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       let base64String = event.target.result;
  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");
  //       // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
  //       const allowedFileTypes = [
  //         "application/pdf",
  //         "image/jpeg",
  //         "image/jpg",
  //         "image/png",
  //         "application/msword", // Allow .doc files
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
  //       ];
  //       const isTypeValid = allowedFileTypes?.includes(file.type);
  //       if (!isTypeValid) {
  //         // Handle the case where the file type is not allowed
  //         Toaster.error({
  //           message: "Error",
  //           description:
  //             "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX.",
  //         });
  //         return;
  //       }
  //       // Pass file name, base64String, and fileType to setGstinFile
  //       setIsoFile({ fileName: file.name, base64String, fileType: file.type });
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     // Handle the case where the file size exceeds 5 MB
  //     Toaster.error({
  //       message: "Error",
  //       description: "File size exceeds 5 MB. Please choose a smaller file.",
  //     });
  //   }
  // };
  // const handlePanCardUpload = (file) => {
  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size <= 5 * 1024 * 1024) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       let base64String = event.target.result;

  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");

  //       // Check if the file type is allowed (PDF, JPG, JPEG, PNG, DOC, DOCX)
  //       const allowedFileTypes = [
  //         "application/pdf",
  //         "image/jpeg",
  //         "image/jpg",
  //         "image/png",
  //         "application/msword",
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //       ];

  //       const isTypeValid = allowedFileTypes?.includes(file.type);

  //       if (!isTypeValid) {
  //         Toaster.error(
  //           "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
  //         );
  //         // Handle the case where the file type is not allowed
  //       } else {
  //         // Pass file name, base64String, and fileType to setPanCardFile only if the file type is valid
  //         setPanCardFile({
  //           fileName: file.name,
  //           base64String,
  //           fileType: file.type,
  //         });
  //       }
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
  //     // Handle the case where the file size exceeds 5 MB
  //   }
  // };

  // const handleGstinUpload = (file) => {
  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size <= 5 * 1024 * 1024) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       let base64String = event.target.result;

  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");
  //       // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
  //       const allowedFileTypes = [
  //         "application/pdf",
  //         "image/jpeg",
  //         "image/jpg",
  //         "image/png",
  //         "application/msword", // Allow .doc files
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
  //       ];
  //       const isTypeValid = allowedFileTypes?.includes(file.type);

  //       if (!isTypeValid) {
  //         Toaster.error(
  //           "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
  //         );
  //         // Handle the case where the file type is not allowed

  //         return;
  //       }
  //       // Pass file name, base64String, and fileType to setGstinFile
  //       setGstinFile({
  //         fileName: file.name,
  //         base64String,
  //         fileType: file.type,
  //       });
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
  //     // Handle the case where the file size exceeds 5 MB or the file type is not allowed
  //   }
  // };
  // const handlefactoryCertificateUpload = (file) => {
  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size <= 5 * 1024 * 1024) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       let base64String = event.target.result;

  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");
  //       // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
  //       const allowedFileTypes = [
  //         "application/pdf",
  //         "image/jpeg",
  //         "image/jpg",
  //         "image/png",
  //         "application/msword", // Allow .doc files
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
  //       ];
  //       const isTypeValid = allowedFileTypes?.includes(file.type);

  //       if (!isTypeValid) {
  //         Toaster.error(
  //           "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
  //         );
  //         // Handle the case where the file type is not allowed

  //         return;
  //       }
  //       // Pass file name, base64String, and fileType to setGstinFile
  //       setFactoryCertificateFile({
  //         fileName: file.name,
  //         base64String,
  //         fileType: file.type,
  //       });
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
  //   }
  // };

  // const handleRegisterUpload = (file) => {
  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size <= 5 * 1024 * 1024) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       let base64String = event.target.result;

  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");
  //       // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
  //       const allowedFileTypes = [
  //         "application/pdf",
  //         "image/jpeg",
  //         "image/jpg",
  //         "image/png",
  //         "application/msword", // Allow .doc files
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
  //       ];
  //       const isTypeValid = allowedFileTypes?.includes(file.type);

  //       if (!isTypeValid) {
  //         Toaster.error(
  //           "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
  //         );

  //         return;
  //       }
  //       // Pass file name, base64String, and fileType to setGstinFile
  //       setRegisterFile({
  //         fileName: file.name,
  //         base64String,
  //         fileType: file.type,
  //       });
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
  //     // Handle the case where the file size exceeds 5 MB
  //   }
  // };
  // const handleRegisterLicenseUpload = (file) => {
  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size <= 5 * 1024 * 1024) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       let base64String = event.target.result;

  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");
  //       // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
  //       const allowedFileTypes = [
  //         "application/pdf",
  //         "image/jpeg",
  //         "image/jpg",
  //         "image/png",
  //         "application/msword", // Allow .doc files
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
  //       ];
  //       const isTypeValid = allowedFileTypes?.includes(file.type);

  //       if (!isTypeValid) {
  //         Toaster.error(
  //           "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
  //         );
  //         // Handle the case where the file type is not allowed

  //         return;
  //       }
  //       // Pass file name, base64String, and fileType to setGstinFile
  //       setRegisterLisenseFile({
  //         fileName: file.name,
  //         base64String,
  //         fileType: file.type,
  //       });
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
  //     // Handle the case where the file size exceeds 5 MB
  //   }
  // };

  // const handleComapnayProfileUpload = (file) => {
  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size <= 5 * 1024 * 1024) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       let base64String = event.target.result;

  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");
  //       // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
  //       const allowedFileTypes = [
  //         "application/pdf",
  //         "application/msword", // .doc (Word)
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx (Word)
  //         "image/jpeg",
  //         "image/jpg",
  //         "image/png",
  //         "application/vnd.ms-excel", // .xls (Excel)
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx (Excel)
  //         "application/vnd.ms-powerpoint", // .ppt (PowerPoint)
  //         "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx (PowerPoint)
  //       ];

  //       if (allowedFileTypes?.includes(file.type)) {
  //         setCompanyProfile({
  //           fileName: file.name,
  //           base64String,
  //           fileType: file.type,
  //         });
  //       } else {
  //         Toaster.error(
  //           "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX), Image (JPEG/JPG/PNG), Excel (XLS/XLSX),PowerPoint (PPT/PPTX)."
  //         );
  //         // Handle the case where the file type is not allowed

  //         return;
  //       }
  //       // Pass file name, base64String, and fileType to setGstinFile
  //       setCompanyProfile({
  //         fileName: file.name,
  //         base64String,
  //         fileType: file.type,
  //       });
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
  //     // Handle the case where the file size exceeds 5 MB
  //   }
  // };
  const handleSelectChange = (value) => {
    setSelectedEstablishmentType(value);

    if (
      value?.value === 1 ||
      value === 1 ||
      value?.value === 6 ||
      value === 6 ||
      value?.value === 4
    ) {
      // setValue('RelatedInputField', null)
      setValue("RelatedInputField", "");
    } else {
      clearErrors("CompanyRegistrationOrLicenseNo");
    }
  };

  /**
   * @method cancel
   * @description used to Reset form
   */
  const cancel = () => {
    history.push("/supplier");
  };
  // 
  const validateFile = (file) => {
    // Check for spaces and special characters in filename
    const hasSpecialChars = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(file.name);
    const hasSpaces = /\s/.test(file.name);

    if (hasSpaces || hasSpecialChars) {
        Toaster.error(
            "Error uploading file. File name should not contain spaces or special characters. Please rename the file and try again."
        );
        return false;
    }

    // Check file size (5MB)
    if (file.size > 5 * 1024 * 1024) {
        Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
        return false;
    }

    return true;
};

const handleIsoCertiicateUpload = (file, e) => {
    try {
        if (!validateFile(file)) return;

        const allowedFileTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        if (!allowedFileTypes.includes(file.type)) {
            Toaster.error(
                "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
            );
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            if (event.target?.result) {
                let base64String = event.target.result;
                base64String = base64String.replace(/^data:(.*?);base64,/, "");
                setIsoFile({ fileName: file.name, base64String, fileType: file.type });
            }
        };

        reader.onerror = () => {
            Toaster.error("Error uploading file, please connect with your IT team");
        };

        reader.readAsDataURL(file);
    } catch (error) {
        Toaster.error("Error uploading file, please connect with your IT team");
        console.error("File upload error:", error);
    }
};

const handlePanCardUpload = (file) => {
    try {
        if (!validateFile(file)) return;

        const allowedFileTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        if (!allowedFileTypes.includes(file.type)) {
            Toaster.error(
                "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
            );
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            if (event.target?.result) {
                let base64String = event.target.result;
                base64String = base64String.replace(/^data:(.*?);base64,/, "");
                setPanCardFile({ fileName: file.name, base64String, fileType: file.type });
            }
        };

        reader.onerror = () => {
            Toaster.error("Error uploading file, please connect with your IT team");
        };

        reader.readAsDataURL(file);
    } catch (error) {
        Toaster.error("Error uploading file, please connect with your IT team");
        console.error("File upload error:", error);
    }
};

const handleGstinUpload = (file) => {
    try {
        if (!validateFile(file)) return;

        const allowedFileTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        if (!allowedFileTypes.includes(file.type)) {
            Toaster.error(
                "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
            );
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            if (event.target?.result) {
                let base64String = event.target.result;
                base64String = base64String.replace(/^data:(.*?);base64,/, "");
                setGstinFile({ fileName: file.name, base64String, fileType: file.type });
            }
        };

        reader.onerror = () => {
            Toaster.error("Error uploading file, please connect with your IT team");
        };

        reader.readAsDataURL(file);
    } catch (error) {
        Toaster.error("Error uploading file, please connect with your IT team");
        console.error("File upload error:", error);
    }
};

const handlefactoryCertificateUpload = (file) => {
    try {
        if (!validateFile(file)) return;

        const allowedFileTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        if (!allowedFileTypes.includes(file.type)) {
            Toaster.error(
                "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
            );
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            if (event.target?.result) {
                let base64String = event.target.result;
                base64String = base64String.replace(/^data:(.*?);base64,/, "");
                setFactoryCertificateFile({ fileName: file.name, base64String, fileType: file.type });
            }
        };

        reader.onerror = () => {
            Toaster.error("Error uploading file, please connect with your IT team");
        };

        reader.readAsDataURL(file);
    } catch (error) {
        Toaster.error("Error uploading file, please connect with your IT team");
        console.error("File upload error:", error);
    }
};

const handleRegisterUpload = (file) => {
    try {
        if (!validateFile(file)) return;

        const allowedFileTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        if (!allowedFileTypes.includes(file.type)) {
            Toaster.error(
                "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
            );
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            if (event.target?.result) {
                let base64String = event.target.result;
                base64String = base64String.replace(/^data:(.*?);base64,/, "");
                setRegisterFile({ fileName: file.name, base64String, fileType: file.type });
            }
        };

        reader.onerror = () => {
            Toaster.error("Error uploading file, please connect with your IT team");
        };

        reader.readAsDataURL(file);
    } catch (error) {
        Toaster.error("Error uploading file, please connect with your IT team");
        console.error("File upload error:", error);
    }
};

const handleRegisterLicenseUpload = (file) => {
    try {
        if (!validateFile(file)) return;

        const allowedFileTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        if (!allowedFileTypes.includes(file.type)) {
            Toaster.error(
                "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
            );
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            if (event.target?.result) {
                let base64String = event.target.result;
                base64String = base64String.replace(/^data:(.*?);base64,/, "");
                setRegisterLisenseFile({ fileName: file.name, base64String, fileType: file.type });
            }
        };

        reader.onerror = () => {
            Toaster.error("Error uploading file, please connect with your IT team");
        };

        reader.readAsDataURL(file);
    } catch (error) {
        Toaster.error("Error uploading file, please connect with your IT team");
        console.error("File upload error:", error);
    }
};

const handleComapnayProfileUpload = (file) => {
    try {
        if (!validateFile(file)) return;

        const allowedFileTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ];

        if (!allowedFileTypes.includes(file.type)) {
            Toaster.error(
                "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX), Image (JPEG/JPG/PNG), Excel (XLS/XLSX), PowerPoint (PPT/PPTX)."
            );
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            if (event.target?.result) {
                let base64String = event.target.result;
                base64String = base64String.replace(/^data:(.*?);base64,/, "");
                setCompanyProfile({ fileName: file.name, base64String, fileType: file.type });
            }
        };

        reader.onerror = () => {
            Toaster.error("Error uploading file, please connect with your IT team");
        };

        reader.readAsDataURL(file);
    } catch (error) {
        Toaster.error("Error uploading file, please connect with your IT team");
        console.error("File upload error:", error);
    }
};
  const checkStateForGSTIN = () => {
    const GISTINNumber = getValues("GISTINNumber");
    const currentState = getValues("State");
    let selectedState = stateOptionData.find(state => state?.Id == currentState?.value);
    if (GISTINNumber && selectedState) {
      return selectedState.GSTCode == GISTINNumber.substring(0, 2);
    }
  };

  const onSubmit = (data, e, isSent) => {

    const GISTINNumber = data?.GISTINNumber;
    const vendorCode = data?.VendorCode;
    const sisterConcernWithQRGVendorCode = data?.SisterConcernWithQRGVendorCode;
    if (GISTINNumber && !checkStateForGSTIN(GISTINNumber) && supplierOrigin == 1) {
      notify.error("Please select the correct state for provided GSTIN Number");
      return;
    }

    if (!isGstValid && GISTINNumber && supplierOrigin == 1) {
      setError('GISTINNumber', {
        type: 'manual',
        message: "The provided GSTIN number is invalid.",
      });
      return;
    }

    if (!isSupplierCodeValid && vendorCode) {
      setError('VendorCode', {
        type: 'manual',
        message: "Invalid supplier code.",
      });
      return;
    }

    if (!isSisterConcernWithQRGVendorCodeValid && sisterConcernWithQRGVendorCode) {
      setError('SisterConcernWithQRGVendorCode', {
        type: 'manual',
        message: "Invalid supplier code.",
      });
      return;
    }

    setSetDisable(true);
    let otherSpecializationString = Array.isArray(data?.OtherSpecialization)
      ? data.OtherSpecialization.map((item) => item.value).join(",")
      : null;
    let empId = userDetails();
    let payload = {
      CompanyName: data?.CompanyName,
      // supplierRepositoryRequestId: detail?.regId,
      SupplierRepositoryRegistrationId: detail?.regId,
      SupplierOrigin: parseInt(supplierOrigin),
      TypeOfEstablishment: parseInt(data?.TypeOfEstablishment?.value),
      RelatedInputField: data?.RelatedInputField
        ? data?.RelatedInputField
        : null,
      YearOfBusinessIncorporation: parseInt(
        data?.YearOfBusinessIncorporation?.value
      ),
      ContactPersonName: data?.ContactPersonName,
      ContactPersonDesignation: data?.ContactPersonDesignation,
      IsExistingSupplier: data?.IsExistingSupplier === "true",
      PANNo: data?.PANNo,
      PanCardAttachment: panCardFile?.base64String
        ? panCardFile
        : panCardFile.isRemove ? {
          fileName: fileData?.PANCardAttachment,
          base64String: "",
          fileType: "",
        } : null,
      GISTINNumberAttachment: gstinFile?.base64String
        ? gstinFile
        : gstinFile.isRemove ? {
          fileName: fileData?.GISTINNumberAttachment,
          base64String: "",
          fileType: "",
        } : null,
      GISTINNumber: data?.GISTINNumber,
      TypeOfBusiness: parseInt(data?.TypeOfBusiness?.value),
      SupplierSpecialization: data?.SupplierSpecialization?.value,
      OtherSpecialization:
        otherSpecializationString || fileData?.OtherSpecialization,
      TotalStaff: parseInt(data?.TotalStaff),
      TotalWorkers: parseInt(data?.TotalWorkers),
      OtherSpecializationExplanation: data?.OtherSpecializationExplanation,
      VendorCode: data?.VendorCode,
      CompanyProfileWebsite: data?.CompanyProfileWebsite,
      HasSisterConcernWithQRG: data?.HasSisterConcernWithQRG === "true",
      SisterConcernWithQRGVendorCode: data?.SisterConcernWithQRGVendorCode,
      HasISO9001OrIATF16949: data?.HasISO9001OrIATF16949 === "true",
      ISO9001IATFCertificateNumber: data?.ISO9001IATFCertificateNumber,
      ISO9001IATFExpiryDate: effectiveDateISO,
      ISO9001IATFCertificateNumberAttachment: isoFile?.base64String
        ? isoFile
        : isoFile.isRemove ? {
          fileName: fileData?.ISO9001IATFCertificateNumberAttachment,
          base64String: "",
          fileType: "",
        } : null,
      FactoryFactoryLicenseAttachment: factoryCertificateFile?.base64String
        ? factoryCertificateFile
        : factoryCertificateFile.isRemove ? {
          fileName: fileData?.FactoryFactoryLicenseAttachment,
          base64String: "",
          fileType: "",
        } : null,
      RegisteredUnderMSMEDActAttachment: registerFile?.base64String
        ? registerFile
        : registerFile.isRemove ? {
          fileName: fileData?.RegisteredUnderMSMEDActAttachment,
          base64String: "",
          fileType: "",
        } : null,
      CompanyRegistrationOrLicenseAttachment: registerLicenseFile?.base64String
        ? registerLicenseFile
        : registerLicenseFile.isRemove ? {
          fileName: fileData?.CompanyRegistrationOrLicenseAttachment,
          base64String: "",
          fileType: "",
        } : null,
      CompanyProfileAttachment: companyProfile?.base64String
        ? companyProfile
        : companyProfile.isRemove ? {
          fileName: fileData?.CompanyProfileAttachment,
          base64String: "",
          fileType: "",
        } : null,
      HasFactoryLicense: data?.HasFactoryLicense === "true",
      FactoryCertificateNo: data?.FactoryCertificateNo,
      FactoryLicenseExpiryDate: effectiveDate,
      HasRelationWithQRGEmployees: data?.HasRelationWithQRGEmployees === "true",
      CompanyInfrastructureService: data?.CompanyInfrastructureService,
      Relation: parseInt(data?.Relation?.value),
      QRGEmployeeCode: data?.QRGEmployeeCode,
      QRGEmployeeName: data?.QRGEmployeeName,
      QRGEmployeeLocation: data?.QRGEmployeeLocation,
      IsRegisteredUnderMSMEDAct: data?.IsRegisteredUnderMSMEDAct === "true",
      OrganizationType: data?.OrganizationType?.value,
      MSMERegistrationNo: data?.MSMERegistrationNo,
      CompanyRegistrationOrLicenseNo: data?.CompanyRegistrationOrLicenseNo,
      LastYearTurnover: parseInt(data.LastYearTurnover),
      LastYearTurnoverCurrency: parseInt(data.LastYearTurnoverCurrency?.value),
      LastYearTurnoverNumberScale: parseInt(
        data.LastYearTurnoverNumberScale?.value
      ),
      Street: data?.Street,
      BuildingPlotNo: data?.BuildingPlotNo,
      Country: data?.Country?.value,
      State: data?.State?.value,
      District: data?.District,
      City: data?.City,
      PostalCode: data?.PostalCode,
      HowDidYouHearAboutUs: data?.HowDidYouHearAboutUs?.value,
      WorkAddressType: workAddressType,
      EmployeeCode: " ",
      Email: data?.Email,
      MobileNo: data?.MobileNo,
      // createdOn: "2023-10-30T10:41:16.854Z",
      // approvedOn: "2023-10-30T10:41:16.854Z",
      // updatedDate: "2023-10-30T10:41:16.854Z",
      requestStatus: 1,
      vendorRegistrationStatus: 1,
      actionTakenByEmployeeId: empId?.EmployeeId,
      SupplierRegisteredByEmployeeID: parseInt(empId?.EmployeeId),
    };
    // If there is no id, it seems like a new submission
    dispatch(
      AddNewSupplierRequest(payload, (res) => {
        if (res && res?.IsSuccessful) {

          Toaster.success(res?.Data?.Message || "Form submission failed");
          settrackkingApplicationId(res?.Data?.RequestNo);
          setShowPopup(true);
          // history.push("/supplier-list-all");
          setSetDisable(false);
          // Toaster.success(res?.Data?.Message);
          const userDetailString = localStorage.getItem("userDetail");
          const userDetail = userDetailString
            ? JSON.parse(userDetailString)
            : {};
          userDetail.IsDataAvailable = true; // or any other update
          localStorage.setItem("userDetail", JSON.stringify(userDetail));
        } else {
          setSetDisable(true);
          Toaster.error(res?.Data?.Message || "Form submission failed");
        }
      })
    );
  };

  async function handleBuisnessTypeChange(selectedValue, emptyOther = true) {
    const specializationRes = await getSupplierSpecializationService(
      selectedValue?.value || selectedValue
    );
    setSupplierSpecialization(specializationRes?.Data?.TypeOfSpecialization);
    if (emptyOther) {
      setValue("SupplierSpecialization", null);
      setValue("OtherSpecialization", null);
      setShowExplanation(false);
    }
  }
  const handleSupplierSpecializationChange = (selectedValue) => {
    setSelectedSupplierSpecialization(selectedValue?.value);
    setShowExplanation(false);
    setValue("OtherSpecialization", null);
    // reset(["OtherSpecialization"]);
  };
  const otherSpecializationData = supplierSpecialization?.filter(
    (option) => option.Id !== selectedSupplierSpecialization
  );
  async function handleCurrencyChange(selectedValue, emptyOther = true) {
    const currencyScaleRespose = await getCurrencyScaleList(
      selectedValue?.value || selectedValue
    );
    setCurrencyScaleData(currencyScaleRespose?.Data?.CurrencyScaleList);
    if (emptyOther) {
      setValue("LastYearTurnoverNumberScale", null);
    }
  }

  async function handleCountryChange(selectedValue, emptyOther = true) {
    const stateRes = await getStateSelection(
      selectedValue?.value || selectedValue
    );
    setOptionData(stateRes?.Data?.StateList);
    if (emptyOther) {
      setValue("State", null);
    }
  }

  async function handleStateChange(selectedValue, emptyOther = true) {
    const districtResponse = await getDistrictSelection(
      selectedValue?.value || selectedValue
    );
    setDistrictOptionData(districtResponse?.Data?.DistrictList);
    if (emptyOther) {
      setCityOptionData([]);
      setValue("District", null);
      setValue("City", null);
    }
  }
  const handleInputChange = (value) => {
    setShowExplanation(!!value); // Set showExplanation based on whether a value is selected
    if (Array.isArray(value) && value.length === 0) {
      setShowExplanation(false);
      // setValue("OtherSpecializationExplanation", null);
    }
  };
  const openPopupForCancel = (type) => {
    setActionType(type);
    setShowPopupForCancel(true);
  };

  const getMessage = () => {
    if (actionType === "cancel") {
      return "Do you want to cancel? All filled information will be lost.";
    } else if (actionType === "back") {
      return "Do you want to go back? All the filled information will be lost.";
    }
    return "";
  };

  const TrackApplicationMessage = () => {
    return (
      <div className="hl-track-modal">
        <div className="fa-success-icon">
          <i className="fa fa-check-circle-o" aria-hidden="true"></i>
        </div>
        <p className="hl-track-thank-you">
          Thank you for expressing interest in becoming a supplier for Havells!
        </p>
        <p>Your details have been successfully submitted.</p>
        <p className="py-2 text-center">
          <strong>
            Your Request ID is -{" "}
            <b className="text-uppercase">{trackkingApplicationId}</b>
          </strong>
        </p>
        <p>
          <span className="pb-2 d-block">
            We anticipate the chance to work together in the future.
          </span>
          Any updates or enhancements to your application status will be
          conveyed via email, and you can also monitor the progress within the
          application tracker.
        </p>
      </div>
    );
  };

  /**
   * @method render
   * @description Renders the component
   */
  const closeSupplierPopUp = () => {
    setShowSupplierOriginPopup(false);
  };

  if (loading || setDisable || showPageLoader) {
    return (
      <div>
        {" "}
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    ); // Render loading indicator if loading is true
  }

  const validateGSTIN = async (gstNumber, notifyMsg = true) => {
    if (gstNumber) {
      setCheckboxChecked(false)
      setShowPageLoader(true);
      gstNumber = gstNumber.toUpperCase();
      let url = `${API.GSTValidate}?GSTIN=${gstNumber}`;
      const request = axiosHelper.get(url);
      request
        .then((response) => {
          if (response.data.IsSuccessful) {
            setIsGstValid(true);
            setShowPageLoader(false);
            if (notifyMsg) {
              notify.success(response.data.FriendlyMessage);
            }
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            const responseData = error.response.data;
            if (!responseData.IsSuccessful) {
              setIsGstValid(false);
              setShowPageLoader(false);
              setError('GISTINNumber', {
                type: 'manual',
                message: responseData.FriendlyMessage,
              });
              return false;
            }
          }
        });
    }
  };

  const validatePANByGstin = (value) => {
    const PANNo = getValues("PANNo"); // Get GSTIN value from the first input field
    const gstinPAN = value?.substring(2, 12); // Extract PAN from GSTIN
    if (PANNo !== gstinPAN && PANNo && value) {
      return "GSTIN and PAN number do not match.";
    }
    return true;
  };

  const validateSupplierCode = async (supplierCode, formFieldKey, notifyMsg = true) => {
    if (supplierCode) {
      setShowPageLoader(true);
      setCheckboxChecked(false)
      supplierCode = supplierCode.toUpperCase();
      let url = `${API.checkSupplierCodeIsValid}?vendorCode=${supplierCode}`;
      const request = axiosHelper.get(url);
      request
        .then((response) => {
          if (response.data.IsSuccessful) {
            setShowPageLoader(false);
            if (formFieldKey === "VendorCode") {
              setIsSupplierCodeValid(true);
            }
            if (formFieldKey === "SisterConcernWithQRGVendorCode") {
              setIsSisterConcernWithQRGVendorCodeValid(true);
            }
            if (notifyMsg) {
              notify.success(response.data.FriendlyMessage);
            }
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            const responseData = error.response.data;
            if (!responseData.IsSuccessful) {
              if (formFieldKey === "VendorCode") {
                setIsSupplierCodeValid(false);
              }
              if (formFieldKey === "SisterConcernWithQRGVendorCode") {
                setIsSisterConcernWithQRGVendorCodeValid(false);
              }
              setShowPageLoader(false);
              setError(formFieldKey, {
                type: 'manual',
                message: responseData.ErrorMessage,
              });
              return false;
            }
          }
        });
    }
  };

  return (
    <div className="container-fluid hl-supplier-form">
      <div className="signup-form">
        {loading ? <LoaderCustom customClass="hl-custom-loader" /> : null}
        <div className="row">
          <div className="col-md-12">
            <div className="shadow-lgg login-formg">
              <Row className={`filter-row-large`}>
                <Col md="4" className="mb-2">
                  <h1>
                    {Mode ? "Update Application Form" : "Application Form"}

                    {Mode && (
                      <span className="hl-request-no pl-3">
                        - ({fileData?.SupplierRepositoryRequestNo})
                      </span>
                    )}
                  </h1>
                </Col>
                {/* <Col md="8" className="mb-3 d-flex justify-content-end">
                  <button
                    type="button"
                    className={"apply mt-1"}
                    // onClick={() => window.history.back()}
                    // onClick={() => setShowPopupForCancel(true)}
                    onClick={() => openPopupForCancel("back")}
                  >
                    <div className={"back-icon"}></div>Back
                  </button>
                </Col> */}
              </Row>
              {showPopup && (
                <PopupMsgWrapper
                  confirmImg={confirmImgMain}
                  firstButtonName={
                    <>
                      <i
                        className="fa fa-paper-plane-o mr-2"
                        aria-hidden="true"
                      ></i>{" "}
                      Track Application
                    </>
                  }
                  secondButtonName="Go Back To Website"
                  header="Response Receipt"
                  isOpen={showPopup}
                  confirmPopup={onPopupConfirm}
                  message={TrackApplicationMessage()}
                  imgClass="hl-img-confirmation d-none"
                  customClass="popup-wrapper-main hl-track-apppopup"
                  closePopUp={false}
                  iconClass="d-none"
                ></PopupMsgWrapper>
              )}
              <div>
                {showSupplierOriginPopup && (
                  <PopupMsgWrapper
                    header="Supplier Origin"
                    isOpen={showSupplierOriginPopup}
                    closePopUp={closeSupplierPopUp}
                    confirmPopup={onConfirmSupplierPopup}
                    message={
                      <>
                        Are you sure you want to change the origin to{" "}
                        {supplierOrigin === "2" ? "Indian" : "Overseas"}?
                        <Alert
                          color="warning"
                          className="p-1 mt-3 hl-warning-msg"
                        >
                          Clicking the OK button will erase the form data on the page.
                        </Alert>
                      </>
                    }
                  />
                )}
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Row className="part-detail-wrapper">
                    <Col md="12">
                      <HeaderTitle
                        title={"Company Details:"}
                        customClass="mt-4"
                      />
                    </Col>
                  </Row>
                  <Row className="part-detail-wrapper">
                    <Col md="3" className="hl-error-cmtitle">
                      <Row className="part-detail-wrapper mt-2">
                        <Col md="12" className="hl-supplier-origin">
                          <div className="hl-title-tooltip">
                            <HeaderTitle
                              title={
                                <>
                                  Supplier Origin:
                                  <TooltipCustom
                                    id="supplierOriginTooltip"
                                    width="360px"
                                    tooltipText={
                                      <>
                                        <ul class="hl-tooltip-list">
                                          <li>Selected supplier is for {supplierOrigin === "1" ? "Indian" : "Overseas"}.</li>
                                          <li>Gray highlighted field can't be changed since it prefilled information during repository approval.</li>
                                        </ul>
                                      </>
                                    }
                                  />
                                </>
                              }
                              customClass="mt-2 hl-supplier-title"
                            />
                          </div>
                          <Label
                            className="d-inline-block align-middle w-auto pl-2 pr-5 mr-5 pr-4 pt-0 radio-box"
                            check
                          >
                            <input
                              type="radio"
                              name="supplierOrigin"
                              className="zero-based"
                              id="1"
                              checked={supplierOrigin === "1"}
                              value="1"
                              onChange={handleSupplierRadioChange}
                              disabled={Mode === "edit"}
                            />
                            <span>Indian</span>
                          </Label>
                          <Label
                            className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                            check
                          >
                            <input
                              type="radio"
                              name="supplierOrigin"
                              className="vendor-based"
                              id="2"
                              checked={supplierOrigin === "2"}
                              value="2"
                              onChange={handleSupplierRadioChange}
                              disabled={Mode === "edit"}
                            />
                            <span>Overseas</span>
                          </Label>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="3" className="hl-error-cmtitle">
                      <TextFieldHookForm
                        {...register("CompanyName")}
                        label={`Company Name`}
                        name={"CompanyName"}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces },
                          maxLength: 200,
                        }}
                        Controller={Controller}
                        control={control}
                        placeholder={"Enter"}
                        handleChange={() => { }}
                        // register={register}
                        // className=""
                        customClassName={"withBorder"}
                        errors={errors.CompanyName}
                        disabled={false}
                        mandatory={true}
                      />
                    </Col>
                    <Col md="3">
                      <SearchableSelectHookForm
                        {...register("TypeOfEstablishment")}
                        label="Type of Establishment"
                        rules={{ required: true }}
                        name="TypeOfEstablishment"
                        placeholder="Select"
                        Controller={Controller}
                        control={control}
                        // register={register}
                        options={renderListing("establishment")}
                        mandatory={true}
                        handleChange={(value) => {
                          handleSelectChange(value);
                        }}
                        errors={errors?.TypeOfEstablishment}
                        disabled={false}
                      />
                    </Col>
                    {supplierOrigin === "1" && (
                      <>
                        {selectedEstablishmentType?.value === 1 ||
                          selectedEstablishmentType === 1 ||
                          selectedEstablishmentType?.value === 6 ||
                          selectedEstablishmentType === 6 ||
                          selectedEstablishmentType?.value === 4 ||
                          selectedEstablishmentType === 4 ? (
                          <Col md="3">
                            <TextFieldHookForm
                              className="text-uppercase"
                              {...register("RelatedInputField")}
                              label={`Enter ${selectedEstablishmentType?.value === 1 ||
                                selectedEstablishmentType === 1
                                ? "CIN"
                                : selectedEstablishmentType?.value === 6 ||
                                  selectedEstablishmentType === 6
                                  ? "OPC"
                                  : selectedEstablishmentType?.value === 4 ||
                                    selectedEstablishmentType === 4
                                    ? "LLP"
                                    : selectedEstablishmentType?.value
                                } Number`}
                              name={"RelatedInputField"}
                              Controller={Controller}
                              control={control}
                              placeholder={"Enter"}
                              handleChange={() => { }}
                              rules={{
                                required:
                                  supplierOrigin === "1" &&
                                  !watch("RelatedInputField"), // Only required if supplierOrigin is "1" and the field is empty
                                validate: { checkWhiteSpaces },
                                maxLength:
                                  selectedEstablishmentType?.value === 4
                                    ? 21 // Maximum length for LLP
                                    : selectedEstablishmentType?.value === 6 ||
                                      selectedEstablishmentType?.value === 1
                                      ? 21 // Maximum length for OPC and CIN
                                      : 41, // Maximum length for other establishment types
                              }}
                              customClassName={"withBorder"}
                              errors={errors.RelatedInputField}
                              disabled={false}
                              mandatory={supplierOrigin === "1"}
                            />
                            {((selectedEstablishmentType?.value === 1) || (selectedEstablishmentType === 1) || (selectedEstablishmentType === 4) || (selectedEstablishmentType?.value === 4) || (selectedEstablishmentType?.value === 6) || (selectedEstablishmentType === 6)) &&
                              <FileUpload
                                control={control}
                                name="CompanyRegistrationOrLicenseAttachment"
                                label="Upload ISO Certificate"
                                onFileChange={(file) => handleRegisterLicenseUpload(file)}
                                onDelete={handleRegisterLicenseDelete}
                                setFile={() => setRegisterLisenseFile}
                                uploadedFile={registerLicenseFile}
                                setUploadedFile={setRegisterLisenseFile}
                                allowedFileTypes={[
                                  "application/pdf",
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                  "application/msword",
                                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                ]} />}
                          </Col>
                        ) : null}
                      </>
                    )}
                    <Col md="3">
                      <SearchableSelectHookForm
                        {...register("YearOfBusinessIncorporation")}
                        label={"Year of Business Incorporation"}
                        name={"YearOfBusinessIncorporation"}
                        placeholder={"Select"}
                        Controller={Controller}
                        control={control}
                        rules={{ required: true }}
                        // register={register}
                        options={renderListing("yearOfBuisness")}
                        mandatory={true}
                        handleChange={() => { }}
                        errors={errors.YearOfBusinessIncorporation}
                        disabled={false}
                      />
                    </Col>
                    {!(Mode === "edit") ? (
                      <>
                        <Col md="3">
                          <SearchableSelectHookForm
                            {...register("TypeOfBusiness")}
                            label={"Type of Business"}
                            name={"TypeOfBusiness"}
                            placeholder={"Select"}
                            Controller={Controller}
                            rules={{ required: true }}
                            control={control}
                            options={renderListing("typeofBuisness")}
                            mandatory={true}
                            handleChange={(selectedValue) =>
                              handleBuisnessTypeChange(selectedValue)
                            }
                            errors={errors.TypeOfBusiness}
                            disabled={false}
                          />
                        </Col>
                        <Col md="3">
                          <SearchableSelectHookForm
                            {...register("SupplierSpecialization")}
                            label={"Supplier Specialization"}
                            name={"SupplierSpecialization"}
                            placeholder={"Select"}
                            rules={{ required: true }}
                            Controller={Controller}
                            control={control}
                            handleChange={(selectedValue) =>
                              handleSupplierSpecializationChange(selectedValue)
                            }
                            options={renderListing("supplierSpecialization")}
                            mandatory={true}
                            errors={errors.SupplierSpecialization}
                            disabled={false}
                          />
                        </Col>
                        <Col md="3" className="hl-other-specialization">
                          <TooltipCustom
                            id="OtherSpecializationTooltip"
                            tooltipText="Let us know if you have other additional specializations."
                          />
                          <SearchableSelectHookForm
                            {...register("OtherSpecialization")}
                            label={"Other Specialization"}
                            name={"OtherSpecialization"}
                            placeholder={"Select"}
                            Controller={Controller}
                            control={control}
                            isMulti={true}
                            options={renderListing("otherSpecialization")}
                            // mandatory={true}
                            handleChange={(selectedValue) =>
                              handleInputChange(selectedValue)
                            }
                            errors={errors.OtherSpecialization}
                          />
                        </Col>
                        {/* {showExplanation && ( */}
                        <Col md="3">
                          <TextAreaHookForm
                            // {...register("OtherSpecializationExplanation")}
                            label={`Explain Specialization`}
                            name={"OtherSpecializationExplanation"}
                            register={register}
                            Controller={Controller}
                            control={control}
                            placeholder={"Enter"}
                            rules={{

                              required: true,
                              validate: { checkWhiteSpaces },
                              maxLength: 250,
                            }}
                            customClassName={"withBorder"}
                            handleChange={() => { }}
                            errors={errors.OtherSpecializationExplanation}
                            disabled={false}
                            mandatory={true}
                            rowHeight={2}
                          />
                        </Col>
                        {/* )} */}
                      </>
                    ) : (
                      <>
                        {fileData?.BusinessTypeName && (
                          <Col md="3">
                            <div className="form-group inputbox withBorder">
                              <label>
                                Type of Business
                                <span className="asterisk-required">*</span>
                              </label>
                              <Controller
                                name="BusinessTypeName"
                                control={control}
                                defaultValue={fileData?.BusinessTypeName}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className="form-control"
                                    type="text"
                                    disabled
                                  />
                                )}
                              />
                            </div>
                          </Col>
                        )}

                        {fileData?.SpecializationName && (
                          <Col md="3">
                            <div className="form-group inputbox withBorder">
                              <label>
                                Supplier Specialization
                                <span className="asterisk-required">*</span>
                              </label>
                              <Controller
                                name="SpecializationName"
                                control={control}
                                defaultValue={fileData?.SpecializationName}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className="form-control"
                                    type="text"
                                    disabled
                                  />
                                )}
                              />
                            </div>
                          </Col>
                        )}

                        {fileData?.OtherSpecializationName && (
                          <Col md="3">
                            <div className="form-group inputbox withBorder">
                              <label>
                                Other Specialization
                                <span className="asterisk-required">*</span>
                              </label>
                              <Controller
                                name="OtherSpecializationName"
                                control={control}
                                defaultValue={fileData?.OtherSpecializationName}
                                render={({ field }) => (
                                  <input
                                    {...field}
                                    className="form-control"
                                    type="text"
                                    disabled
                                  />
                                )}
                              />
                            </div>
                          </Col>
                        )}
                        {fileData?.OtherSpecializationExplanation && (
                          <Col md="3">
                            <div className="form-group inputbox withBorder">
                              <label>
                                Explain Specialization
                                <span className="asterisk-required">*</span>
                              </label>
                              <Controller
                                name="OtherSpecializationExplanation"
                                control={control}
                                defaultValue={
                                  fileData?.OtherSpecializationExplanation
                                }
                                render={({ field }) => (
                                  <textarea
                                    {...field}
                                    className="form-control"
                                    type="text"
                                    disabled
                                  />
                                )}
                              />
                            </div>
                          </Col>
                        )}
                      </>
                    )}
                    {supplierOrigin === "2" &&
                      <Col md="3">
                        <div className="d-flex align-items-center">
                          <div className="fullinput-icon">
                            <TooltipCustom
                              id="registrationTooltip"
                              tooltipText={
                                <>
                                  <ul className="hl-tooltip-list">
                                    <li>Please attach a copy of Registration/License.</li>
                                    <li>Allowed file formats: PDF, DOC, JPG, PNG.</li>
                                  </ul>
                                </>
                              }
                            />
                            <TextFieldHookForm
                              {...register("CompanyRegistrationOrLicenseNo")}
                              label={
                                supplierOrigin === "2"
                                && "Unified Social Credit Identifier (USCI)/ Business Licence Number"

                              }
                              name={"CompanyRegistrationOrLicenseNo"}
                              Controller={Controller}
                              control={control}
                              placeholder={"Enter"}
                              rules={{
                                maxLength: 25,
                                validate: {
                                  checkWhiteSpaces,
                                  alphaNumeric,
                                },
                                required:
                                  supplierOrigin === "1" &&
                                  (selectedEstablishmentType?.value === 1 ||
                                    selectedEstablishmentType === 1 ||
                                    selectedEstablishmentType?.value === 6 ||
                                    selectedEstablishmentType === 6 ||
                                    selectedEstablishmentType?.value === 4 ||
                                    selectedEstablishmentType === 4),
                              }}
                              customClassName={"withBorder mb-0"}
                              handleChange={() => { }}
                              errors={errors.CompanyRegistrationOrLicenseNo}
                              disabled={false}
                              mandatory={
                                supplierOrigin === "1" &&
                                (selectedEstablishmentType?.value === 1 ||
                                  selectedEstablishmentType === 1 ||
                                  selectedEstablishmentType?.value === 6 ||
                                  selectedEstablishmentType === 6 ||
                                  selectedEstablishmentType?.value === 4 ||
                                  selectedEstablishmentType === 4)
                              }
                              className="text-uppercase"
                            />

                            {/* Display error message */}
                          </div>
                          <FileUpload
                            control={control}
                            name="CompanyRegistrationOrLicenseAttachment"
                            label="Upload ISO Certificate"
                            uploadClass="mt-2 hl-mb-0 hl-isocert-upload"
                            onFileChange={(file) =>
                              handleRegisterLicenseUpload(file)
                            }
                            onDelete={handleRegisterLicenseDelete}
                            setFile={() => setRegisterLisenseFile}
                            uploadedFile={registerLicenseFile}
                            setUplaodedFile={setRegisterLisenseFile}
                            allowedFileTypes={[
                              "application/pdf",
                              "image/jpeg",
                              "image/jpg",
                              "image/png",
                              "application/msword",
                              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                            ]}
                          />
                        </div>
                      </Col>}
                    <Col md="3">
                      <SearchableSelectHookForm
                        {...register("LastYearTurnoverCurrency")}
                        label={"Currency"}
                        name={"LastYearTurnoverCurrency"}
                        placeholder={"Select"}
                        Controller={Controller}
                        control={control}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces },
                          maxLength: 50,
                        }}
                        // register={register}

                        options={renderListing("currencyList")}
                        mandatory={true}
                        handleChange={(selectedValue) =>
                          handleCurrencyChange(selectedValue)
                        }
                        errors={errors.LastYearTurnoverCurrency}
                        disabled={isDateValid}
                      />
                    </Col>
                    <Col md="3">
                      <TooltipCustom
                        id="turnoverTooltip"
                        tooltipText={
                          <>
                            Enter the revenue in numbers first and then select the unit.
                            <br />
                            Ex- If your revenue is 200,000 you can simply write 2 in the text box and select lakh as the unit.
                          </>
                        }
                      />
                      <TextFieldHookForm
                        {...register("LastYearTurnover")}
                        label={`Last Year Turnover?`}
                        name={"LastYearTurnover"}
                        Controller={Controller}
                        control={control}
                        placeholder={"Enter"}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces, numberHavells },
                          maxLength: 15,
                        }}
                        // register={register}
                        // className=""
                        customClassName={"withBorder"}
                        handleChange={() => { }}
                        errors={errors.LastYearTurnover}
                        disabled={false}
                        mandatory={true}
                      />
                    </Col>
                    <Col md="3">
                      <SearchableSelectHookForm
                        {...register("LastYearTurnoverNumberScale")}
                        label={"Last Year Turnover Number Scale"}
                        name={"LastYearTurnoverNumberScale"}
                        placeholder={"Select"}
                        Controller={Controller}
                        control={control}
                        rules={{ required: true }}
                        // register={register}
                        options={renderListing("currencyListScale")}
                        mandatory={true}
                        handleChange={() => { }}
                        errors={errors.LastYearTurnoverNumberScale}
                        disabled={false}
                      />
                    </Col>
                    <Col md="3">
                      <TextFieldHookForm
                        {...register("TotalStaff")}
                        label={`Total Staff`}
                        name={"TotalStaff"}
                        Controller={Controller}
                        control={control}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces, numberHavells },
                          maxLength: 12,
                        }}
                        placeholder={"Enter"}
                        handleChange={() => { }}
                        customClassName={"withBorder"}
                        errors={errors.TotalStaff}
                        disabled={false}
                        mandatory={true}
                      />
                    </Col>
                    <Col md="3">
                      <TextFieldHookForm
                        {...register("TotalWorkers")}
                        label={`Total Workers`}
                        name={"TotalWorkers"}
                        Controller={Controller}
                        control={control}
                        placeholder={"Enter"}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces, numberHavells },
                          maxLength: 12,
                        }}
                        className=""
                        customClassName={"withBorder"}
                        handleChange={() => { }}
                        errors={errors.TotalWorkers}
                        disabled={false}
                        mandatory={true}
                      />
                    </Col>
                    <Col md="3">
                      <TooltipCustom
                        id="companyInfrastructureServiceTooltip"
                        tooltipText="Tell us about your machinery, customers, land size, backward integration etc."
                      />
                      <TextAreaHookForm
                        {...register("CompanyInfrastructureService")}
                        label={"Explain Company Infrastructure/Service"}
                        name={"CompanyInfrastructureService"}
                        rules={{
                          required: false,
                          validate: { checkWhiteSpaces },
                          maxLength: 250,
                        }}
                        placeholder={true ? "Enter" : "Type here..."}
                        Controller={Controller}
                        control={control}
                        // register={register}
                        mandatory={false}
                        customClassName={"withBorder"}
                        handleChange={() => { }}
                        errors={errors.CompanyInfrastructureService}
                        disabled={false}
                        rowHeight={2}
                      />
                    </Col>
                    <Col md="3">
                      <TextFieldHookForm
                        {...register("CompanyProfileWebsite")}
                        label={`Website`}
                        name={"CompanyProfileWebsite"}
                        Controller={Controller}
                        control={control}
                        placeholder={"Enter"}
                        rules={{
                          required: false,
                          validate: { checkWhiteSpaces, validateUrlHavells },
                          maxLength: 50,
                        }}
                        customClassName={"withBorder mb-0"}
                        handleChange={() => { }}
                        errors={errors.CompanyProfileWebsite}
                        disabled={false}
                        mandatory={false}
                      />
                    </Col>
                    <Col md="3" className="mb-3">
                      <div className="hl-title-tooltip">
                        <label>
                          Company Profile{" "}
                          <TooltipCustom
                            id="companyProfileTooltip"
                            tooltipText="Allowed file formats: PNG, JPG, PPT, DOC, XLS, PDF."
                          />
                        </label>
                      </div>
                      <FileUpload
                        control={control}
                        name="CompanyProfileAttachment"
                        uploaMainWrap="hl-upload-main"
                        // label="Upload Comapny profile"
                        uploadClass="mt-1 hl-mb-0 hl-profile-upld"
                        onFileChange={(file) =>
                          handleComapnayProfileUpload(file)
                        }
                        onDelete={handleCompanyProfileDelete}
                        setFile={() => setCompanyProfile}
                        uploadedFile={companyProfile}
                        setUplaodedFile={setCompanyProfile}
                        allowedFileTypes={[
                          "application/pdf",
                          "application/msword", // .doc (Word)
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx (Word)
                          "image/jpeg",
                          "image/jpg",
                          "image/png",
                          "application/vnd.ms-excel", // .xls (Excel)
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx (Excel)
                          "application/vnd.ms-powerpoint", // .ppt (PowerPoint)
                          "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx (PowerPoint)
                        ]}
                      />
                    </Col>
                  </Row>
                  <hr className="hr-seprator mb-4" />
                  <Row className="part-detail-wrapper">
                    <Col md="12">
                      <HeaderTitle title={"Contact Details:"} customClass="mt-4" />
                    </Col>
                    <Col md="3">
                      <TooltipCustom
                        id="emailTooltip"
                        tooltipText="Primary email for communication for this application."
                      />
                      <TextFieldHookForm
                        {...register("Email")}
                        label={`Email Address`}
                        name={"Email"}
                        Controller={Controller}
                        control={control}
                        placeholder={"Enter"}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces, email },
                          maxLength: 50,
                        }}
                        handleChange={() => { }}
                        customClassName={"withBorder"}
                        errors={errors.Email}
                        // disabled={true}
                        mandatory={true}
                      />
                    </Col>
                    <Col md="3">
                      <TooltipCustom
                        id="mobileNoTooltip"
                        tooltipText="Primary mobile number for communication for this application."
                      />
                      <TextFieldHookForm
                        {...register("MobileNo")}
                        label={`Contact Number`}
                        name={"MobileNo"}
                        Controller={Controller}
                        control={control}
                        placeholder={"Enter"}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces, numberHavells },
                          maxLength: supplierOrigin === "1" ? 10 : 15,
                        }}
                        customClassName={"withBorder"}
                        errors={errors.MobileNo}
                        handleChange={() => { }}
                        // disabled={true}
                        mandatory={true}
                      />
                    </Col>
                    <Col md="3">
                      <TextFieldHookForm
                        {...register("ContactPersonName")}
                        label={`Contact Person Name`}
                        name={"ContactPersonName"}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces, alphaNumeric },
                          maxLength: 50,
                        }}
                        Controller={Controller}
                        control={control}
                        placeholder={"Enter"}
                        handleChange={() => { }}
                        // register={register}
                        // className=""
                        customClassName={"withBorder"}
                        errors={errors.ContactPersonName}
                        disabled={false}
                        mandatory={true}
                      />
                    </Col>
                    <Col md="3">
                      <TextFieldHookForm
                        {...register("ContactPersonDesignation")}
                        label={`Contact Person Designation`}
                        name={"ContactPersonDesignation"}
                        Controller={Controller}
                        control={control}
                        handleChange={() => { }}
                        placeholder={"Enter"}
                        // register={register}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces, alphaNumeric },
                          maxLength: 50,
                        }}
                        // className=""
                        customClassName={"withBorder"}
                        errors={errors.ContactPersonDesignation}
                        disabled={false}
                        mandatory={true}
                      />
                    </Col>
                  </Row>
                  <hr className="hr-seprator" />
                  <Row className="part-detail-wrapper">
                    <Col md="12">
                      <HeaderTitle title={"Work Address:"} customClass="mt-4" />
                    </Col>
                    <Col md="3">
                      <Row className="part-detail-wrapper">
                        <Col md="12">
                          <Label>What type of work address do you have?<span className="asterisk-required">*</span></Label>
                        </Col>
                        <Col md="12">
                          <Label
                            className={
                              "d-inline-block align-middle w-auto pl0 pr-4 mb-3  pt-0 radio-box"
                            }
                            check
                          >
                            <input
                              type="radio"
                              name="WorkAddressType"
                              className="zero-based"
                              id="workAddressTypeOwned"
                              {...register("WorkAddressType")}
                              value="true"
                              // defaultChecked={workAddressType === true}
                              defaultChecked
                              checked={workAddressType === true}
                              onChange={() => setWorkAddressType(true)}
                            />{" "}
                            <span>Owned</span>
                          </Label>
                          <Label
                            className={
                              "d-inline-block align-middle w-auto pl0 pr-4 mb-3  pt-0 radio-box"
                            }
                            check
                          >
                            <input
                              type="radio"
                              name="WorkAddressType"
                              className="vendor-based"
                              id="workAddressTypeRented"
                              {...register("WorkAddressType")}
                              value="false"
                              checked={workAddressType === false}
                              onChange={() => setWorkAddressType(false)}
                            />{" "}
                            <span>Rented</span>
                          </Label>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="3">
                      <TextFieldHookForm
                        {...register("BuildingPlotNo")}
                        label={`Building/Plot No.`}
                        name={"BuildingPlotNo"}
                        Controller={Controller}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces },
                          maxLength: 100,
                        }}
                        control={control}
                        placeholder={"Enter"}
                        handleChange={() => { }}
                        // register={register}
                        // className=""
                        customClassName={"withBorder"}
                        errors={errors.BuildingPlotNo}
                        disabled={false}
                        mandatory={true}
                      />
                    </Col>
                    <Col md="3">
                      <TextFieldHookForm
                        {...register("Street")}
                        label={`Street`}
                        name={"Street"}
                        Controller={Controller}
                        control={control}
                        placeholder={"Enter"}
                        handleChange={() => { }}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces },
                          maxLength: 100,
                        }}
                        customClassName={"withBorder"}
                        errors={errors.Street}
                        disabled={false}
                        mandatory={true}
                      />
                    </Col>
                    <Col md="3">
                      <TextFieldHookForm
                        {...register("City")}
                        label={`City`}
                        name={"City"}
                        Controller={Controller}
                        control={control}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces, alphaNumeric },
                          maxLength: 50,
                        }}
                        placeholder={"Enter"}
                        register={register}
                        options={renderListing("City")}
                        mandatory={true}
                        handleChange={() => { }}
                        errors={errors.City}
                        customClassName={"withBorder"}
                        disabled={false}
                      />
                    </Col>
                    <Col md="3">
                      <TextFieldHookForm
                        {...register("District")}
                        label={`District`}
                        name={"District"}
                        Controller={Controller}
                        control={control}
                        rules={{
                          required: supplierOrigin === "1",
                          validate: { checkWhiteSpaces, alphaNumeric },
                          maxLength: 50,
                        }}
                        placeholder={"Enter"}
                        register={register}
                        className=""
                        customClassName={"withBorder"}
                        errors={errors.District}
                        handleChange={() => { }}
                        disabled={false}
                        mandatory={supplierOrigin === "1"}
                      />
                    </Col>
                    <Col md="3">
                      <SearchableSelectHookForm
                        {...register("Country")}
                        label={"Country"}
                        name={"Country"}
                        placeholder={"Select"}
                        Controller={Controller}
                        control={control}
                        rules={{ required: true }}
                        register={register}
                        options={renderListing("Country")}
                        mandatory={true}
                        handleChange={(value) => {
                          handleCountryChange(value);
                        }}
                        errors={errors.Country}
                        disabled={isDateValid}
                      />
                    </Col>
                    <Col md="3">
                      <SearchableSelectHookForm
                        {...register("State")}
                        label={"State/Region"}
                        name={"State"}
                        placeholder={"Select"}
                        Controller={Controller}
                        control={control}
                        rules={{ required: true }}
                        // register={register}
                        handleChange={(value) => {
                          // handleStateChange(value);
                        }}
                        options={renderListing("State")}
                        mandatory={true}
                        // handleChange={() => { }}
                        errors={errors.State}
                        disabled={false}
                      />
                    </Col>
                    <Col md="3">
                      <TextFieldHookForm
                        {...register("PostalCode")}
                        label={`Postal Code/Zip Code`}
                        name={"PostalCode"}
                        Controller={Controller}
                        control={control}
                        rules={{
                          required: true,
                          validate: {
                            checkWhiteSpaces,
                            ...(supplierOrigin === "2"
                              ? { alphaNumeric }
                              : { numberHavells }),
                          },
                          maxLength: 10,
                          minLength: {
                            value: supplierOrigin === "2" ? 4 : 6,
                            message:
                              supplierOrigin === "2"
                                ? "Minimum length is 4 characters."
                                : "Minimum length is 6 digits.",
                          },
                        }}
                        placeholder={"Enter"}
                        register={register}
                        className=""
                        customClassName={"withBorder"}
                        errors={errors.PostalCode}
                        handleChange={() => { }}
                        disabled={false}
                        mandatory={true}
                      />
                    </Col>
                  </Row>
                  <hr className="hr-seprator mb-4" />
                  <Row className="part-detail-wrapper">
                    <Col md="12">
                      <HeaderTitle title={"Statutory Details:"} customClass="mt-4" />
                    </Col>
                    <Col md="12">
                      <Row>
                        {supplierOrigin === "1" && (
                          <Col md="3">
                            <div className="d-flex align-items-center">
                              <div className="fullinput-icon">
                                <TooltipCustom
                                  id="panNoTooltip"
                                  tooltipText={
                                    <>
                                      <ul className="hl-tooltip-list">
                                        <li>Please attach a copy of PAN Card.</li>
                                        <li>Allowed file formats: PDF, DOC, JPG, PNG.</li>
                                      </ul>
                                    </>
                                  }
                                />
                                <TextFieldHookForm
                                  {...register("PANNo")}
                                  label={`PAN Number`}
                                  name={"PANNo"}
                                  Controller={Controller}
                                  handleChange={(e) => {
                                    const uppercaseValue =
                                      e.target.value.toUpperCase(); // Convert input value to uppercase
                                    e.target.value = uppercaseValue;
                                  }}
                                  rules={{
                                    required: true,
                                    validate: {
                                      checkWhiteSpaces,
                                      // validatePANByGstin,
                                    },
                                    pattern: {
                                      value: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
                                      message: "Invalid PAN Number format.",
                                    },
                                    maxLength: 10,
                                  }}
                                  control={control}
                                  placeholder={"Enter"}
                                  customClassName={"withBorder"}
                                  errors={errors.PANNo}
                                  disabled={false}
                                  mandatory={true}
                                  className="text-uppercase"
                                />
                              </div>
                              <FileUpload
                                uploadClass="hl-gstin-upload hl-pan-upload"
                                control={control}
                                name="PanCardAttachment"
                                label="Upload PanCard"
                                onFileChange={(file) => handlePanCardUpload(file)}
                                onDelete={handlePanCardDelete}
                                setFile={panCardFile}
                                uploadedFile={panCardFile}
                                setUplaodedFile={setPanCardFile}
                                allowedFileTypes={[
                                  "application/pdf",
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                  "application/msword",
                                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                ]}
                              />
                            </div>
                          </Col>
                        )}
                        {supplierOrigin === "1" && (
                          <Col md="3">
                            <div className="d-flex align-items-center">
                              <div className="fullinput-icon">
                                <TooltipCustom
                                  id="gISTINNumberTooltip"
                                  tooltipText={
                                    <>
                                      <ul className="hl-tooltip-list">
                                        <li>Please attach GSTIN Certificate.</li>
                                        <li>Allowed file formats: PDF, DOC, JPG, PNG.</li>
                                      </ul>
                                    </>
                                  }
                                />
                                <TextFieldHookForm
                                  {...register("GISTINNumber", {
                                    required: "GSTIN Number is required.",
                                    // pattern: {
                                    //   value:
                                    //     // /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[0-9A-Z]{1}[0-9]{1}$/,
                                    //     // /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/,
                                    //     /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9A-Z]{1}$/,
                                    //   message: "Invalid GSTIN Number format.",
                                    // },
                                  })}
                                  label="GSTIN Number"
                                  name="GISTINNumber"
                                  Controller={Controller}
                                  control={control}
                                  placeholder="Enter"
                                  rules={{
                                    required: false,
                                    validate: {
                                      checkWhiteSpaces,
                                      validatePANByGstin
                                    },
                                    maxLength: 15,
                                    minLength: {
                                      value: 15,
                                      message: "Minimum length is 15 digits.",
                                    },
                                  }}
                                  handleChange={(e) => {
                                    setIsGstValid(false);
                                    setHasGSTINChanged(true);
                                    const uppercaseValue =
                                      e.target.value.toUpperCase(); // Convert input value to uppercase
                                    e.target.value = uppercaseValue;
                                  }}
                                  customClassName="withBorder"
                                  errors={errors?.GISTINNumber}
                                  disabled={false}
                                  className="text-uppercase"
                                  onFieldBlur={(e) => {
                                    if (hasGSTINChanged) {
                                      validateGSTIN(e.target.value);
                                      setHasGSTINChanged(false);
                                    }
                                  }}
                                />
                              </div>
                              <FileUpload
                                uploadClass="hl-gstin-upload"
                                control={control}
                                name="GISTINNumberAttachment"
                                label="Upload GST Attachment"
                                onFileChange={(file) => handleGstinUpload(file)}
                                onDelete={handleGSTINDelete}
                                setFile={() => setGstinFile}
                                uploadedFile={gstinFile}
                                setUplaodedFile={setGstinFile}
                                allowedFileTypes={[
                                  "application/pdf",
                                  "image/jpeg",
                                  "image/jpg",
                                  "image/png",
                                  "application/msword",
                                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                ]}
                              />
                            </div>
                          </Col>
                        )}
                      </Row>
                    </Col>
                    <Col md="12">
                      <Row className="part-detail-wrapper">
                        <Col md="12">
                          <Label>Do you have ISO 9001/IATF 16949? <span className="asterisk-required">*</span>
                          </Label>
                        </Col>
                        <Col md="12">
                          <Label className={"d-inline-block align-middle w-auto pl0 pr-5 mr-5 mb-3 pt-0 radio-box"} check >
                            <input
                              type="radio"
                              name="HasISO9001OrIATF16949"
                              className="zero-based"
                              {...register("HasISO9001OrIATF16949", {
                                required: true,
                              })}
                              id="HasISO9001OrIATF16949true"
                              value="true"
                            />{" "}
                            <span>Yes</span>
                          </Label>
                          <Label className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"} check >
                            <input
                              type="radio"
                              {...register("HasISO9001OrIATF16949", {
                                required: true,
                              })}
                              name="HasISO9001OrIATF16949"
                              className="vendor-based2"
                              id="HasISO9001OrIATF16949False"
                              value="false"
                            />{" "}
                            <span>No</span>
                          </Label>
                        </Col>
                        <Col md="3">
                          {watch("HasISO9001OrIATF16949") === "true" && (
                            <TextFieldHookForm
                              {...register("ISO9001IATFCertificateNumber")}
                              label={`Certificate Number`}
                              name={"ISO9001IATFCertificateNumber"}
                              Controller={Controller}
                              rules={{
                                required: true,
                                validate: { checkWhiteSpaces },
                                maxLength: 25,
                              }}
                              control={control}
                              placeholder={"Enter"}
                              // register={register}
                              // className=""
                              customClassName={"withBorder mb-0"}
                              handleChange={() => { }}
                              errors={errors.ISO9001IATFCertificateNumber}
                              disabled={false}
                              mandatory={true}
                              className="text-uppercase"
                            />
                          )}
                        </Col>
                        <Col md="3">
                          {watch("HasISO9001OrIATF16949") === "true" && (
                            <>
                              <div className="d-flex align-items-center">
                                <div className="fullinput-icon">
                                  <TooltipCustom
                                    id="ISO9001IATFExpiryDateTooltip"
                                    tooltipText="Allowed file formats: PDF, DOC, JPG, PNG."
                                  />
                                  <label>
                                    Expiry Date
                                    <span className="asterisk-required">*</span>
                                  </label>
                                  <div className="inputbox date-section">
                                    <DatePicker
                                      {...register("ISO9001IATFExpiryDate", {
                                        required: "Please select a date.",
                                        validate: { checkWhiteSpaces },
                                        maxLength: 50,
                                      })}
                                      selected={
                                        DayTime(effectiveDateISO).isValid()
                                          ? DayTime(effectiveDateISO).toDate()
                                          : null
                                      }
                                      onChange={(date) => {
                                        setValue(
                                          "ISO9001IATFExpiryDate",
                                          date,
                                          { shouldValidate: true }
                                        );
                                        setEffectiveDateISO(
                                          DayTime(
                                            date,
                                            "YYYY-MM-DDTHH:mm:ss.SSSZ"
                                          ).format("MM/DD/YYYY")
                                        );
                                      }}
                                      name="ISO9001IATFExpiryDate"
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      dateFormat="dd/MM/yyyy"
                                      placeholderText="Select"
                                      className="withBorder mb-0"
                                      autoComplete="off"
                                      disabledKeyboardNavigation
                                      onChangeRaw={(e) => e.preventDefault()}
                                      minDate={new Date()}
                                    />
                                    {errors.ISO9001IATFExpiryDate && (
                                      <span className="text-help">
                                        {errors.ISO9001IATFExpiryDate.message}
                                      </span>
                                    )}
                                  </div>
                                  <div className="inputbox date-section"></div>
                                </div>
                                <FileUpload
                                  uploadClass="hl-iso-upload"
                                  control={control}
                                  name="ISO9001IATFCertificateNumberAttachment"
                                  label="Upload ISO Certificate"
                                  onFileChange={(file) =>
                                    handleIsoCertiicateUpload(file)
                                  }
                                  onDelete={handlISODelete}
                                  setFile={() => setIsoFile}
                                  uploadedFile={isoFile}
                                  setUplaodedFile={setIsoFile}
                                  allowedFileTypes={[
                                    "application/pdf",
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "application/msword", // Allow .doc files
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
                                  ]}
                                />
                              </div>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col md="12">
                      <Row className="part-detail-wrapper">
                        <Col md="12">
                          <Label>Do you have a Factory License? <span className="asterisk-required">*</span></Label>
                        </Col>
                        <Col md="12">
                          <Label
                            className={
                              "d-inline-block align-middle w-auto pl0 pr-5 mr-5 mb-3 pt-0 radio-box"
                            }
                            check
                          >
                            <input
                              type="radio"
                              name="HasFactoryLicense"
                              className="zero-based"
                              {...register("HasFactoryLicense", {
                                required: true,
                              })}
                              id="HasFactoryLicenseTrue"
                              value="true"
                            />{" "}
                            <span>Yes</span>
                          </Label>
                          <Label
                            className={
                              "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                            }
                            check
                          >
                            <input
                              type="radio"
                              {...register("HasFactoryLicense", {
                                required: true,
                              })}
                              name="HasFactoryLicense"
                              className="vendor-based2"
                              id="HasFactoryLicenseFalse"
                              value="false"
                            />{" "}
                            <span>No</span>
                          </Label>
                        </Col>
                        <Col md="3">
                          {watch("HasFactoryLicense") === "true" && (
                            <TextFieldHookForm
                              {...register("FactoryCertificateNo")}
                              label={`Factory License Number`}
                              name={"FactoryCertificateNo"}
                              Controller={Controller}
                              rules={{
                                required: true,
                                validate: { checkWhiteSpaces },
                                maxLength: 25,
                              }}
                              control={control}
                              placeholder={"Enter"}
                              // register={register}
                              // className=""
                              customClassName={"withBorder mb-0"}
                              handleChange={() => { }}
                              errors={errors.FactoryCertificateNo}
                              disabled={false}
                              mandatory={true}
                              className="text-uppercase"
                            />
                          )}
                        </Col>
                        <Col md="3">
                          {watch("HasFactoryLicense") === "true" && (
                            <>
                              <div className="d-flex align-items-center">
                                <div className="fullinput-icon">
                                  <TooltipCustom
                                    id="factoryLicenseExpiryDateTooltip"
                                    tooltipText="Allowed file formats: PDF, DOC, JPG, PNG."
                                  />
                                  <label>
                                    Expiry Date
                                    <span className="asterisk-required">*</span>
                                  </label>
                                  <div className="inputbox date-section">
                                    <DatePicker
                                      {...register("FactoryLicenseExpiryDate", {
                                        required: "Please select a date.",
                                        validate: { checkWhiteSpaces },
                                        maxLength: 50,
                                      })}
                                      name="FactoryLicenseExpiryDate"
                                      // selected={watch("FactoryLicenseExpiryDate") || null}
                                      selected={
                                        DayTime(effectiveDate).isValid()
                                          ? DayTime(effectiveDate).toDate()
                                          : null
                                      }
                                      onChange={(date) => {
                                        setValue(
                                          "FactoryLicenseExpiryDate",
                                          date,
                                          { shouldValidate: true }
                                        );
                                        setEffectiveDate(
                                          DayTime(
                                            date,
                                            "YYYY-MM-DDTHH:mm:ss.SSSZ"
                                          ).format("MM/DD/YYYY")
                                        );
                                      }}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      dateFormat="dd/MM/yyyy"
                                      placeholderText="Select"
                                      className="withBorder"
                                      autoComplete={"off"}
                                      disabledKeyboardNavigation
                                      onChangeRaw={(e) => e.preventDefault()}
                                      minDate={new Date()}
                                    />
                                    {effectiveDate === null &&
                                      errors.FactoryLicenseExpiryDate && (
                                        <span className="text-help">
                                          {
                                            errors.FactoryLicenseExpiryDate
                                              .message
                                          }
                                        </span>
                                      )}
                                  </div>
                                </div>
                                <FileUpload
                                  control={control}
                                  name="FactoryFactoryLicenseAttachment"
                                  label="Factory Licence Upload"
                                  uploadClass="hl-upload-align hl-factory-upload"
                                  onFileChange={(file) =>
                                    handlefactoryCertificateUpload(file)
                                  }
                                  onDelete={handleFactoryFactoryLicenseAttachmentFile}
                                  setFile={() => setFactoryCertificateFile}
                                  uploadedFile={factoryCertificateFile}
                                  setUplaodedFile={setFactoryCertificateFile}
                                  allowedFileTypes={[
                                    "application/pdf",
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "application/msword",
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                  ]}
                                />
                              </div>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col md="12" className="mt-3">
                      {supplierOrigin === "1" && (
                        <Row className="part-detail-wrapper">
                          <Col md="12">
                            <Label>Is your Organization Registered under Micro, Small, or Medium Enterprises (MSMED Act 2006) <span className="asterisk-required">*</span></Label>
                          </Col>
                          <Col md="12">
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl0 pr-5 mr-5 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="IsRegisteredUnderMSMEDAct"
                                {...register("IsRegisteredUnderMSMEDAct", {
                                  required: true,
                                })}
                                className="zero-based"
                                id="IsRegisteredUnderMSMEDActTrue"
                                value="true"
                              />{" "}
                              <span>Yes</span>
                            </Label>
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="IsRegisteredUnderMSMEDAct"
                                {...register("IsRegisteredUnderMSMEDAct", {
                                  required: true,
                                })}
                                className="vendor-based"
                                id="IsRegisteredUnderMSMEDActFalse"
                                value="false"
                              />{" "}
                              <span>No</span>
                            </Label>
                          </Col>
                          <Col md="3">
                            {watch("IsRegisteredUnderMSMEDAct") ===
                              "true" && (
                                <SearchableSelectHookForm
                                  {...register("OrganizationType")}
                                  label={"MSME Type"}
                                  name={"OrganizationType"}
                                  placeholder={"Select"}
                                  Controller={Controller}
                                  control={control}
                                  rules={{ required: true }}
                                  options={renderListing("relationEmployee")}
                                  // register={register}
                                  // options={renderListing("yearOfBuisness")}
                                  mandatory={true}
                                  handleChange={() => { }}
                                  errors={errors.OrganizationType}
                                  disabled={false}
                                  customClassName={"mb-0"}
                                />
                              )}
                          </Col>
                          <Col md="3">
                            {watch("IsRegisteredUnderMSMEDAct") ===
                              "true" && (
                                <div className="d-flex align-items-center">
                                  <div className="fullinput-icon">
                                    <TooltipCustom
                                      id="msmeRegistrationNoTooltip"
                                      tooltipText={
                                        <>
                                          <ul className="hl-tooltip-list">
                                            <li>Please attach latest copy with latest date of Registration Certificate.</li>
                                            <li>Allowed file formats: PDF, DOC, JPG, PNG.</li>
                                          </ul>
                                        </>
                                      }
                                    />
                                    <TextFieldHookForm
                                      {...register("MSMERegistrationNo")}
                                      label={`UAM Number`}
                                      name={"MSMERegistrationNo"}
                                      Controller={Controller}
                                      control={control}
                                      placeholder={"Enter"}
                                      rules={{
                                        required: true,
                                        validate: { checkWhiteSpaces },
                                        maxLength: 25,
                                      }}
                                      // register={register}
                                      // className=""
                                      customClassName={"withBorder mb-0"}
                                      handleChange={() => { }}
                                      errors={errors.MSMERegistrationNo}
                                      disabled={false}
                                      mandatory={true}
                                      className="text-uppercase"
                                    />
                                  </div>
                                  <FileUpload
                                    control={control}
                                    name="RegisteredUnderMSMEDActAttachment"
                                    label="Upload Register Certificate"
                                    uploadClass="mt-2 hl-mb-0 hl-register-upload"
                                    onFileChange={(file) =>
                                      handleRegisterUpload(file)
                                    }
                                    onDelete={handleRegisterDelete}
                                    setFile={() => setRegisterFile}
                                    uploadedFile={registerFile}
                                    setUplaodedFile={setRegisterFile}
                                    allowedFileTypes={[
                                      "application/pdf",
                                      "image/jpeg",
                                      "image/jpg",
                                      "image/png",
                                      "application/msword",
                                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                    ]}
                                  />
                                </div>
                              )}
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                  <hr className="hr-seprator mb-4" />
                  <Row className="part-detail-wrapper">
                    <Col md="12">
                      <HeaderTitle title={"Other Details:"} customClass="mt-4" />
                    </Col>
                  </Row>
                  <Row className="part-detail-wrapper">
                    <Col md="3">
                      <Row>
                        <Col md="12">
                          <Label>Do you have any Existing or Past Supplier code?<span className="asterisk-required">*</span>
                          </Label>
                        </Col>
                        <Col md="12">
                          <Label
                            className={
                              "d-inline-block align-middle w-auto pl0 pr-5 mr-5 mb-3 pt-0 radio-box"
                            }
                            check
                          >
                            <input
                              type="radio"
                              name="IsExistingSupplier"
                              className="zero-based"
                              id="IsExistingSupplierTrue"
                              {...register("IsExistingSupplier", {
                                required: true,
                              })}
                              // value={true}
                              value="true"
                            // checked={watch("IsExistingSupplier")?true:false}
                            />
                            <span>Yes</span>
                          </Label>
                          <Label
                            className={
                              "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                            }
                            check
                          >
                            <input
                              type="radio"
                              name="IsExistingSupplier"
                              className="vendor-based"
                              id="IsExistingSupplierFalse"
                              {...register("IsExistingSupplier", {
                                required: true,
                              })}
                              // value={false}
                              value="false"
                            // checked={watch("IsExistingSupplier")?false:true}
                            />
                            <span>No</span>
                          </Label>
                        </Col>
                        <Col md="12">
                          {watch("IsExistingSupplier") === "true" && (
                            <TextFieldHookForm
                              {...register("VendorCode")}
                              label={`Supplier Code`}
                              name={"VendorCode"}
                              Controller={Controller}
                              control={control}
                              placeholder={"Enter"}
                              rules={{
                                required: true,
                                validate: { checkWhiteSpaces, alphaNumeric },
                                maxLength: 15,
                              }}
                              // register={register}
                              // className=""
                              customClassName={"withBorder mb-0"}
                              errors={errors.VendorCode}
                              disabled={false}
                              mandatory={true}
                              className="text-uppercase"
                              handleChange={(e) => {
                                setIsSupplierCodeValid(false);
                                setHasSupplierCodeChanged(true);
                                const uppercaseValue =
                                  e.target.value.toUpperCase(); // Convert input value to uppercase
                                e.target.value = uppercaseValue;
                              }}
                              onFieldBlur={(e) => {
                                if (hasSupplierCodeChanged) {
                                  validateSupplierCode(e.target.value, "VendorCode");
                                  setHasSupplierCodeChanged(false);
                                }
                              }}
                            />
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col md="9">
                      <Row>
                        <Col md="12">
                          <Label>Do you have another Sister Concern which is Supplying to Havells Group?<span className="asterisk-required">*</span></Label>
                        </Col>
                        <Col md="12">
                          <Label
                            className={
                              "d-inline-block align-middle w-auto pl0 pr-5 mr-5 mb-3 pt-0 radio-box"
                            }
                            check
                          >
                            <input
                              type="radio"
                              name="HasSisterConcernWithQRG"
                              {...register("HasSisterConcernWithQRG", {
                                required: true,
                              })}
                              className="zero-based"
                              id="HasSisterConcernWithQRGTrue"
                              value="true"
                            />{" "}
                            <span>Yes</span>
                          </Label>
                          <Label
                            className={
                              "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                            }
                            check
                          >
                            <input
                              type="radio"
                              name="HasSisterConcernWithQRG"
                              className="vendor-based"
                              {...register("HasSisterConcernWithQRG", {
                                required: true,
                              })}
                              id="HasSisterConcernWithQRGFalse"
                              value="false"
                            />{" "}
                            <span>No</span>
                          </Label>
                        </Col>
                        <Col md="4">
                          {watch("HasSisterConcernWithQRG") === "true" && (
                            <TextFieldHookForm
                              {...register("SisterConcernWithQRGVendorCode")}
                              label={`Sister Concern Supplier Code`}
                              name={"SisterConcernWithQRGVendorCode"}
                              Controller={Controller}
                              control={control}
                              placeholder={"Enter"}
                              rules={{
                                required: true,
                                validate: { checkWhiteSpaces, alphaNumeric },
                                maxLength: 15,
                              }}
                              // register={register}
                              // className=""
                              customClassName={"withBorder mb-0"}
                              errors={errors.SisterConcernWithQRGVendorCode}
                              disabled={false}
                              mandatory={true}
                              className="text-uppercase"
                              handleChange={(e) => {
                                setIsSisterConcernWithQRGVendorCodeValid(false);
                                setHasSisterConcernWithQRGVendorCodeChanged(true);
                                const uppercaseValue =
                                  e.target.value.toUpperCase(); // Convert input value to uppercase
                                e.target.value = uppercaseValue;
                              }}
                              onFieldBlur={(e) => {
                                if (hasSisterConcernWithQRGVendorCodeChanged) {
                                  validateSupplierCode(e.target.value, "SisterConcernWithQRGVendorCode");
                                  setHasSisterConcernWithQRGVendorCodeChanged(false);
                                }
                              }}
                            />
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col md="12">
                      <Row className="part-detail-wrapper">
                        <Col md="14">
                          <Label>
                            Do you have another Relationship with any Havells Employees?<span className="asterisk-required">*</span>
                          </Label>
                        </Col>
                        <Col md="12">
                          <Label
                            className={
                              "d-inline-block align-middle w-auto pl0 pr-5 mr-5 mb-3 pt-0 radio-box"
                            }
                            check
                          >
                            <input
                              type="radio"
                              name="HasRelationWithQRGEmployees"
                              className="zero-based"
                              {...register("HasRelationWithQRGEmployees", {
                                required: true,
                              })}
                              id="HasRelationWithQRGEmployeesTrue"
                              value="true"
                            />{" "}
                            <span>Yes</span>
                          </Label>
                          <Label
                            className={
                              "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                            }
                            check
                          >
                            <input
                              type="radio"
                              name="HasRelationWithQRGEmployees"
                              {...register("HasRelationWithQRGEmployees", {
                                required: true,
                              })}
                              className="vendor-based"
                              id="HasRelationWithQRGEmployeesFalse"
                              value="false"
                            />{" "}
                            <span>No</span>
                          </Label>
                        </Col>
                        <Col md="12">
                          <Row>
                            <Col md="3">
                              {watch("HasRelationWithQRGEmployees") === "true" && (
                                <SearchableSelectHookForm
                                  {...register("Relation")}
                                  label={"Relation with Employee"}
                                  name={"Relation"}
                                  placeholder={"Select"}
                                  Controller={Controller}
                                  control={control}
                                  rules={{ required: true }}
                                  // register={register}
                                  options={renderListing("relationEmployeeListing")}
                                  mandatory={true}
                                  handleChange={() => { }}
                                  errors={errors.Relation}
                                  disabled={false}
                                />
                              )}
                            </Col>
                            <Col md="3">
                              {watch("HasRelationWithQRGEmployees") === "true" && (
                                <TextFieldHookForm
                                  label={`Havells Employee Code`}
                                  name={"QRGEmployeeCode"}
                                  Controller={Controller}
                                  control={control}
                                  placeholder={"Enter"}
                                  handleChange={() => { }}
                                  rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces, alphaNumeric },
                                    maxLength: 15,
                                  }}
                                  customClassName={"withBorder"}
                                  errors={errors.QRGEmployeeCode}
                                  disabled={false}
                                  mandatory={true}
                                  className="text-uppercase"
                                />
                              )}
                            </Col>
                            <Col md="3">
                              {watch("HasRelationWithQRGEmployees") === "true" && (
                                <TextFieldHookForm
                                  label={`Havells Employee Name`}
                                  name={"QRGEmployeeName"}
                                  Controller={Controller}
                                  control={control}
                                  placeholder={"Enter"}
                                  handleChange={() => { }}
                                  rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces, alphabetsOnly },
                                    maxLength: 50,
                                  }}
                                  customClassName={"withBorder mb-0"}
                                  errors={errors.QRGEmployeeName}
                                  disabled={false}
                                  mandatory={true}
                                />
                              )}
                            </Col>
                            <Col md="3">
                              {watch("HasRelationWithQRGEmployees") === "true" && (
                                <TextFieldHookForm
                                  label={`Havells Employee Location`}
                                  name={"QRGEmployeeLocation"}
                                  Controller={Controller}
                                  control={control}
                                  placeholder={"Enter"}
                                  handleChange={() => { }}
                                  rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces, alphabetsOnly },
                                    maxLength: 50,
                                  }}
                                  customClassName={"withBorder mb-0"}
                                  errors={errors.QRGEmployeeLocation}
                                  disabled={false}
                                  mandatory={true}
                                />
                              )}
                            </Col>
                          </Row>
                        </Col>
                        <Col md="3">
                          <SearchableSelectHookForm
                            {...register("HowDidYouHearAboutUs")}
                            label={"How did you hear About Us?"}
                            name={"HowDidYouHearAboutUs"}
                            placeholder={"Select"}
                            Controller={Controller}
                            control={control}
                            rules={{ required: true }}
                            register={register}
                            options={renderListing("HowDidYouHear")}
                            mandatory={true}
                            handleChange={() => { }}
                            errors={errors.HowDidYouHearAboutUs}
                            disabled={false}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer">
                    <div className="col-sm-12 text-right bluefooter-butn">
                      {Mode ? (
                        ""
                      ) : (
                        <label className="w-auto mr-5 pr-5 custom-checkbox">
                          I confirm that the above information is correct.
                          <input
                            type="checkbox"
                            onClick={handleCheckboxClick}
                            className="mr-2"
                          />
                          <span className="before-box"></span>
                        </label>
                      )}
                      <button
                        type={"button"}
                        className="reset mr-2 cancel-btn"
                        disabled={setDisable}
                        // onClick={() => setShowPopupForCancel(true)}
                        onClick={() => openPopupForCancel("cancel")}
                      >
                        <div className={"cancel-icon"}></div>
                        {"Cancel"}
                      </button>
                      {setDisable === true ? (
                        <button
                          type="submit"
                          className="submit-button save-btn hl-btn-loader"
                          disabled={setDisable}
                        >
                          <div className="save-icon"></div>
                          {"Submit"}
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="submit-button save-btn"
                          disabled={Mode ? false : !checkboxChecked}
                        >
                          <div className="save-icon"></div>
                          {Mode ? "Update" : "Submit"}
                        </button>
                      )}
                    </div>
                  </Row>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPopupForCancel && (
        <PopupMsgWrapper
          isOpen={showPopupForCancel}
          closePopUp={closePopUpForCancel}
          confirmPopup={onPopupConfirmForCancel}
          message={getMessage()}
        />
      )}
      {/* </Drawer > */}
    </div>
  );
}
export default AddNewSupplier;
